const xe = "1.0", Ce = 10, z = {
  ANCHOR: 0.4,
  PATH: 0.3,
  TARGET: 0.2,
  UNIQUENESS: 0.1
}, I = {
  SEMANTIC_TAG: 0.5,
  ROLE: 0.3,
  ARIA_LABEL: 0.1,
  STABLE_ID: 0.25,
  TEST_MARKER: 0.05,
  DEPTH_PENALTY_THRESHOLD: 5,
  DEPTH_PENALTY_FACTOR: 0.05,
  DEGRADED_SCORE: 0.3
}, yt = {
  MIN_CONFIDENCE_FOR_SKIP: 0.7
}, tt = [
  "form",
  "main",
  "nav",
  "section",
  "article",
  "footer",
  "header"
], et = [
  "form",
  "navigation",
  "main",
  "region",
  "contentinfo",
  "complementary",
  "banner",
  "search"
], St = [
  // HTML5 Semantic
  "article",
  "aside",
  "details",
  "figcaption",
  "figure",
  "footer",
  "header",
  "main",
  "mark",
  "nav",
  "section",
  "summary",
  "time",
  // Form elements
  "button",
  "datalist",
  "fieldset",
  "form",
  "input",
  "label",
  "legend",
  "meter",
  "optgroup",
  "option",
  "output",
  "progress",
  "select",
  "textarea",
  // Interactive
  "a",
  "audio",
  "video",
  "canvas",
  "dialog",
  "menu",
  // Text content
  "blockquote",
  "dd",
  "dl",
  "dt",
  "hr",
  "li",
  "ol",
  "ul",
  "p",
  "pre",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  // Table
  "caption",
  "col",
  "colgroup",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "tr",
  // SVG
  "svg",
  "path",
  "circle",
  "rect",
  "line",
  "polyline",
  "polygon",
  "ellipse",
  "g",
  "text",
  "use"
], At = [
  "rect",
  "path",
  "circle",
  "line",
  "polyline",
  "polygon",
  "ellipse",
  "g",
  "text",
  "use",
  "defs",
  "clipPath",
  "mask"
], Te = [
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "name",
  "type",
  "data-testid",
  "data-qa",
  "data-test",
  "href",
  "title",
  "placeholder",
  "alt"
], w = {
  // Test attributes (highest priority)
  "data-testid": 100,
  "data-qa": 99,
  "data-cy": 98,
  "data-test": 97,
  "data-test-id": 96,
  // ARIA (accessibility semantics)
  "aria-label": 90,
  "aria-labelledby": 85,
  "aria-describedby": 80,
  // Semantic HTML attributes
  name: 75,
  href: 70,
  // for <a>
  src: 70,
  // for <img>, <script>, etc.
  type: 65,
  role: 60,
  alt: 55,
  title: 50,
  for: 45,
  placeholder: 40,
  // Any data-* attribute (if not above)
  "data-*": 30,
  // Any aria-* attribute (if not above)
  "aria-*": 25
}, Y = /* @__PURE__ */ new Set([
  "id",
  // handled separately
  "class",
  // handled separately
  "style",
  // unstable
  "xmlns",
  // service attribute for SVG
  "tabindex",
  // can change
  "contenteditable"
]), xt = {
  maxPathDepth: 10,
  enableSvgFingerprint: !0,
  confidenceThreshold: 0,
  fallbackToBody: !0,
  includeUtilityClasses: !1,
  source: "dom-dsl"
}, Ct = {
  strictMode: !1,
  enableFallback: !0,
  maxCandidates: 20,
  matchUrlsByPathOnly: !0
};
function L(r) {
  if (/^[a-z]+-\d+$/i.test(r) || /^[a-z]+(-[a-z]+)+-\d+$/i.test(r) || /^[a-z]+(_[a-z]+)*_\d+$/i.test(r) || /^\d+$/.test(r) || /^:[a-z0-9]+:$/i.test(r) || /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(r))
    return !0;
  if (/^[a-z]{1,3}[A-Za-z0-9]{8,}$/.test(r)) {
    const t = /\d/.test(r), e = /[A-Z]/.test(r), s = r.length >= 20;
    if (t && e || s)
      return !0;
  }
  return !!(/^radix-/.test(r) || /^mui-\d+$/.test(r));
}
const Z = /* @__PURE__ */ new Set([
  "aria-labelledby",
  "aria-describedby",
  "aria-controls",
  "aria-owns",
  "aria-activedescendant",
  "for",
  "form",
  "list",
  "headers",
  "aria-details",
  "aria-errormessage",
  "aria-flowto"
]);
function K(r) {
  return r.trim().split(/\s+/).some((e) => L(e));
}
class Tt {
  constructor(t, e) {
    this.maxDepth = t.maxPathDepth ?? 10, this.cache = e;
  }
  /**
   * Finds the best anchor element for the target
   * @param target - Target element to find anchor for
   * @returns Anchor result or null if not found
   * @remarks
   * Special handling for root elements (html, head, body):
   * - For html: returns html itself as anchor
   * - For head or elements inside head: returns html as anchor
   * - For body: returns html as anchor
   */
  findAnchor(t) {
    if (this.cache) {
      const c = this.cache.getAnchor(t);
      if (c !== void 0)
        return c;
    }
    const e = t.tagName.toLowerCase(), s = t.ownerDocument;
    if (e === "html") {
      const c = {
        element: t,
        score: 1,
        tier: "A",
        depth: 0
      };
      return this.cacheResult(t, c), c;
    }
    if (e === "head" || this.isInsideHead(t)) {
      const c = s?.documentElement;
      if (c) {
        const l = {
          element: c,
          score: 1,
          tier: "A",
          depth: 0
        };
        return this.cacheResult(t, l), l;
      }
    }
    if (e === "body") {
      const c = s?.documentElement;
      if (c) {
        const l = {
          element: c,
          score: 1,
          tier: "A",
          depth: 0
        };
        return this.cacheResult(t, l), l;
      }
    }
    let n = t.parentElement, a = 0, i = null;
    for (; n && a < this.maxDepth; ) {
      if (n.tagName.toLowerCase() === "body")
        return i || {
          element: n,
          score: I.DEGRADED_SCORE,
          tier: "C",
          depth: a
        };
      const c = this.scoreAnchor(n);
      if (c > 0) {
        const l = this.applyDepthPenalty(c, a), f = this.getTier(n), h = { element: n, score: l, tier: f, depth: a };
        if (f === "A")
          return h;
        (!i || l > i.score) && (i = h);
      }
      n = n.parentElement, a++;
    }
    const o = i;
    return this.cache && this.cache.setAnchor(t, o), o;
  }
  /**
   * Scores an element as anchor candidate (without depth penalty)
   * @param element - Element to score
   * @returns Raw score from 0 to 1
   */
  scoreAnchor(t) {
    let e = 0;
    const s = t.tagName.toLowerCase();
    tt.includes(s) && (e += I.SEMANTIC_TAG);
    const n = t.getAttribute("role");
    n && et.includes(n) && (e += I.ROLE), (t.hasAttribute("aria-label") || t.hasAttribute("aria-labelledby")) && (e += I.ARIA_LABEL);
    const a = t.id;
    return a && !L(a) && (e += I.STABLE_ID), (t.hasAttribute("data-testid") || t.hasAttribute("data-qa") || t.hasAttribute("data-test")) && (e += I.TEST_MARKER), Math.min(e, 1);
  }
  /**
   * Applies depth penalty to score
   * Following SPECIFICATION.md §7: depthPenalty = (depth - threshold) * factor
   */
  applyDepthPenalty(t, e) {
    if (e <= I.DEPTH_PENALTY_THRESHOLD)
      return t;
    const s = (e - I.DEPTH_PENALTY_THRESHOLD) * I.DEPTH_PENALTY_FACTOR;
    return Math.max(0, t - s);
  }
  /**
   * Determines the tier of an anchor element
   */
  getTier(t) {
    const e = t.tagName.toLowerCase();
    if (tt.includes(e))
      return "A";
    const s = t.getAttribute("role");
    return s && et.includes(s) ? "B" : "C";
  }
  /**
   * Checks if element is inside <head> section.
   * Stops at <body> to avoid false positives.
   * @param element - Element to check
   * @returns True if element is inside head, false otherwise
   * @remarks
   * Traverses up the DOM tree until finding head or body.
   * Returns false if body is encountered first.
   * @example
   * const meta = document.querySelector('meta');
   * if (isInsideHead(meta)) { ... }
   */
  isInsideHead(t) {
    let e = t.parentElement;
    for (; e; ) {
      const s = e.tagName.toLowerCase();
      if (s === "head") return !0;
      if (s === "body") return !1;
      e = e.parentElement;
    }
    return !1;
  }
  /**
   * Caches the anchor result for the target element
   * @param target - Target element
   * @param result - Anchor result to cache
   */
  cacheResult(t, e) {
    this.cache && this.cache.setAnchor(t, e);
  }
}
const Et = [
  // CSS-in-JS
  /^css-[a-z0-9]+$/i,
  /^sc-[a-z0-9]+-\d+$/i,
  /^[a-z]{5,8}$/i,
  // Short generated classes (abcdef)
  // Material-UI / MUI
  /^Mui[A-Z]\w+-\w+-\w+/,
  /^makeStyles-\w+-\d+$/,
  // JSS
  /^jss\d+$/,
  // Emotion / Linaria
  /^(emotion|linaria)-[a-z0-9]+/i,
  // Component libraries with hashes
  /^(chakra|tw-|ant-)[a-z0-9]+-\w+/i,
  // Hash-based (hashes in classes)
  /-[a-f0-9]{6,}$/i,
  /^_[a-z0-9]{5,}$/i,
  /\d{5,}/
  // 5+ digits in a row
], wt = [
  // === FIX 4: Tailwind arbitrary values and variants (highest priority) ===
  /^\[/,
  // Any arbitrary value or variant starting with [ (e.g., [&_svg]:..., [mask-type:luminance])
  // === FIX 4: Pseudo-class variants (must be before specific patterns) ===
  /^(first|last|odd|even|only|first-of-type|last-of-type|only-of-type):/,
  // first:, last:, etc.
  /^(hover|focus|active|disabled|enabled|checked|indeterminate|default|required|valid|invalid|in-range|out-of-range|placeholder-shown|autofill|read-only):/,
  // State pseudo-classes
  /^(focus-within|focus-visible|visited|target|open):/,
  // Advanced pseudo-classes
  // === FIX 4: Responsive variants (must be before specific patterns) ===
  /^(sm|md|lg|xl|2xl|3xl|4xl|5xl|6xl|7xl):/,
  // === FIX 4: Dark mode and directional variants ===
  /^dark:/,
  /^(rtl|ltr):/,
  // === FIX 4: Group and peer variants ===
  /^(group|peer)(-hover|-focus|-active)?:/,
  // === Arbitrary pseudo-class/modifier variants (catch-all) ===
  // Matches any lowercase/hyphenated prefix followed by colon
  // e.g., file:bg-transparent, placeholder:text-gray, invalid:border-red, accept:text-primary
  // Must come AFTER semantic pattern checks to avoid false positives
  /^[a-z][a-z-]*:/,
  // === FIX 4: Tailwind utilities with fraction values ===
  /\/([\d.]+|full|auto|screen)$/,
  // /50, /100, /full, /auto, /screen
  // === FIX 4: Positioning utilities ===
  /^(inset|top|right|bottom|left)(-|$)/,
  // inset-0, top-0, left-0
  // === Layout & Display ===
  /^(flex|inline-flex|grid|block|inline|inline-block|hidden|visible)$/,
  /^(absolute|relative|fixed|sticky|static)$/,
  // === Flexbox & Grid ===
  /^(items|justify|content|self|place)-/,
  /^flex-(row|col|wrap|nowrap|1|auto|initial|none)/,
  /^grid-(cols|rows|flow)/,
  // === Spacing (Tailwind) ===
  /^(gap|space)-/,
  /^[mp][trblxy]?-(\d+|auto|px)$/,
  // === Negative Tailwind utilities (margins, positioning, transforms) ===
  /^-[mp][trblxy]?-\d+$/,
  // -m-4, -mt-2, -mx-4, -px-4, -py-2
  /^-(top|right|bottom|left|inset)-\d+$/,
  // -top-4, -bottom-6, -left-6, -inset-0
  /^-z-\d+$/,
  // -z-10, -z-20
  /^-space-[xy]-\d+$/,
  // -space-x-2, -space-y-4
  /^-translate-[xy]-\d+$/,
  // -translate-x-4, -translate-y-2
  /^-rotate-\d+$/,
  // -rotate-45, -rotate-90
  /^-scale-\d+$/,
  // -scale-50, -scale-75
  /^-skew-[xy]-\d+$/,
  // -skew-x-12, -skew-y-6
  // === Sizing ===
  /^(w|h|min-w|min-h|max-w|max-h|size)-/,
  // === Colors & Styling ===
  // Note: text-* can be semantic (text-muted, text-primary) or utility (text-center, text-lg)
  // More specific patterns for utility text-* classes
  /^text-(center|left|right|justify|start|end|xs|sm|base|lg|xl|2xl|3xl|4xl|5xl|6xl|7xl|8xl|9xl)$/,
  /^text-(uppercase|lowercase|capitalize|normal-case|underline|line-through|no-underline)$/,
  /^text-(truncate|ellipsis|clip)$/,
  // shadcn/ui theme color tokens: color utilities ending in -foreground/-background
  // e.g. text-muted-foreground, text-primary-foreground, bg-card-foreground, text-foreground
  /^(text|bg|border|ring|fill|stroke|outline|divide|placeholder|caret|accent|decoration|shadow|from|via|to)-([a-z]+-)*(foreground|background)$/,
  // shadcn/ui theme color tokens used as text color (text- is otherwise kept narrow).
  // Omits input/border/ring/sidebar/chart-* on purpose: rare as text color and prone to
  // colliding with semantic component names (e.g. a "text-input" field component).
  /^text-(primary|secondary|muted|accent|destructive|popover|card|foreground|background)$/,
  /^(bg|border|ring|shadow|outline)-/,
  // SVG paint and niche color namespaces (always color values, never identity):
  // fill-*, stroke-*, caret-*, decoration-*, divide-*, placeholder-*, ring-offset-*
  /^(fill|stroke|caret|decoration|divide|placeholder|ring-offset)-/,
  /^rounded(-|$)/,
  // === Typography ===
  /^(font|leading|tracking|whitespace|break|truncate)-/,
  /^(uppercase|lowercase|capitalize|normal-case)$/,
  // === Transform & Animation (IMPORTANT!) ===
  /^(transform|transition|duration|delay|ease|animate)-/,
  /^(scale|rotate|translate|skew)-/,
  /^transform$/,
  /^backdrop-blur-/,
  /^motion-/,
  // Framer Motion
  /^(fade|slide|zoom|bounce|pulse|spin|ping)-/,
  // animations
  // === Overflow & Scrolling ===
  /^(overflow|overscroll|scroll)-/,
  /^object-(contain|cover|fill|none|scale-down)$/,
  // === Interactivity ===
  /^(cursor|pointer-events|select|resize)-/,
  // === Visibility & Opacity ===
  /^(opacity|z)-/,
  /^(visible|invisible|collapse)$/,
  // === Bootstrap utilities ===
  /^d-(none|inline|inline-block|block|grid|table|flex)$/,
  /^(float|clearfix|text)-(left|right|center|justify|start|end)$/,
  /^(m|p)[trblxy]?-[0-5]$/,
  /^(w|h)-(25|50|75|100|auto)$/,
  // Note: btn-* classes are semantic (component classes), not utility
  // /^btn-(primary|secondary|success|danger|warning|info|light|dark|link)$/,
  /^btn-(sm|lg|block)$/,
  // Only size modifiers are utility
  /^text-(muted|primary|success|danger|warning|info|light|dark|white)$/,
  /^bg-(primary|secondary|success|danger|warning|info|light|dark|white|transparent)$/,
  /^border(-top|-bottom|-left|-right)?(-0)?$/,
  /^rounded(-top|-bottom|-left|-right|-circle|-pill|-0)?$/,
  /^shadow(-sm|-lg|-none)?$/,
  /^(align|justify|order|flex)-(start|end|center|between|around|fill|grow|shrink)$/,
  /^col(-sm|-md|-lg|-xl)?(-\d+|-auto)?$/,
  /^row(-cols)?(-\d+)?$/,
  /^g[xy]?-[0-5]$/,
  /^(show|hide|invisible|visible)$/,
  /^(position|top|bottom|start|end)-(static|relative|absolute|fixed|sticky|-\d+)$/,
  // === Common utility patterns ===
  /^(row|col)$/,
  /^clearfix$/,
  /^pull-(left|right)$/,
  /^float-(left|right|none)$/
], vt = [
  // === Navigation ===
  /^(nav|menu|header|footer|sidebar|topbar|navbar|breadcrumb)/,
  /(navigation|dropdown|megamenu)$/,
  // === Components ===
  /^(btn|button|link|card|modal|dialog|popup|tooltip|alert|badge|chip)/,
  /^(form|input|select|checkbox|radio|textarea|label|fieldset)/,
  /^(table|list|item|row|cell|column)/,
  /^(accordion|tab|carousel|slider|gallery)/,
  // === Content ===
  /^(content|main|article|post|comment|title|subtitle|description|caption)/,
  /^(hero|banner|jumbotron|section|wrapper|box)/,
  // === User/Data ===
  /^(user|profile|avatar|account|auth)/,
  /^(product|item|price|cart|checkout|order)/,
  // === Layout sections ===
  /^(page|layout|panel|widget|block)/,
  // === States (semantic naming) ===
  /-(primary|secondary|tertiary|success|error|warning|info|danger)$/,
  /-(active|inactive|disabled|enabled|selected|highlighted|focused)$/,
  /-(open|closed|expanded|collapsed|visible|hidden)$/,
  /-(large|medium|small|tiny|xs|sm|md|lg|xl)$/,
  // === Action buttons ===
  /^(submit|cancel|close|delete|edit|save|back|next|prev|search)/,
  // === Status ===
  /^(loading|pending|complete|failed|draft|published)/
];
function lt(r) {
  return r.replace(/^!/, "").replace(/!$/, "");
}
function q(r) {
  const t = lt(r);
  return Et.some((e) => e.test(t));
}
function U(r) {
  const t = lt(r);
  return t.length <= 2 || /^\d/.test(t) ? !0 : wt.some((e) => e.test(t));
}
function $t(r) {
  return q(r) || U(r) ? !1 : vt.some((t) => t.test(r));
}
function Nt(r) {
  return !q(r) && !U(r);
}
function M(r) {
  return r.filter((t) => Nt(t));
}
function It(r) {
  if (q(r) || U(r))
    return 0;
  let t = 0.5;
  return $t(r) && (t = 0.8), r.length < 3 ? t *= 0.3 : r.length < 5 && (t *= 0.6), /\d/.test(r) && (t *= 0.7), Math.min(t, 1);
}
function Rt(r) {
  const t = [], e = [];
  for (const s of r)
    U(s) || q(s) ? e.push(s) : t.push(s);
  return { semantic: t, utility: e };
}
function st(r) {
  return U(r) || q(r);
}
function Ee(r) {
  return It(r);
}
const Dt = /* @__PURE__ */ new Set([
  "tr",
  "td",
  "th",
  "thead",
  "tbody",
  "tfoot"
]), Mt = /* @__PURE__ */ new Set([
  "data-testid",
  "data-qa",
  "data-cy",
  "data-test",
  "aria-label",
  "name",
  "href"
]);
function Lt(r) {
  if (r.id) return !0;
  if (r.attributes) {
    for (const t of Object.keys(r.attributes))
      if (Mt.has(t)) return !0;
  }
  return !1;
}
function Pt(r, t, e) {
  const s = r.parentElement;
  if (!s) return !0;
  for (const n of Array.from(s.children)) {
    if (n === r || n.tagName.toLowerCase() !== t) continue;
    if ((n.textContent?.trim() ?? "") === e) return !1;
  }
  return !0;
}
function _(r, t, e) {
  if (Dt.has(r)) return !0;
  if (Lt(t)) return !1;
  if (e) {
    const s = e.parentElement;
    if (s) {
      const n = t.text?.normalized;
      if (n && Pt(e, r, n))
        return !1;
      if (Array.from(s.children).some(
        (i) => i !== e && i.tagName.toLowerCase() === r
      )) return !0;
    }
    return !1;
  }
  return !0;
}
const rt = (r) => r.replace(/([#:.[\]@])/g, "\\$1");
class Ht {
  constructor(t, e) {
    this.maxDepth = t.maxPathDepth ?? 10, this.cache = e;
  }
  /**
   * Builds path from anchor to target (excluding both)
   * @param anchor - Anchor element (start)
   * @param target - Target element (end)
   * @param extractor - Semantic extractor instance
   * @returns Path build result with nodes and degradation info
   * @remarks
   * Special handling for root elements:
   * - If anchor is html and target is head/body: returns empty path
   * - If anchor is html and target is inside head: builds path through head
   */
  buildPath(t, e, s) {
    const n = t.tagName.toLowerCase(), a = e.tagName.toLowerCase();
    if (n === "html" && (a === "head" || a === "body"))
      return {
        path: [],
        degraded: !1
      };
    if (n === "html" && this.isInsideHead(e))
      return this.buildHeadPath(t, e, s);
    const i = [];
    let o = e.parentElement;
    for (; o && o !== t && i.length < this.maxDepth; )
      i.unshift(o), o = o.parentElement;
    const c = i.length >= this.maxDepth && o !== t;
    if (!c && o !== t)
      return console.warn("[PathBuilder] Target is not a descendant of anchor"), {
        path: [],
        degraded: !0,
        degradationReason: "target-not-descendant-of-anchor"
      };
    let l = this.filterNoise(i);
    return l = this.ensureUniqueness(i, l, t, e, s), {
      path: l.map((h) => {
        const d = h.tagName.toLowerCase(), u = s.extract(h);
        let g;
        if (_(d, u, h)) {
          const m = h.parentElement;
          if (m) {
            const b = Array.from(m.children).indexOf(h);
            b !== -1 && (g = b + 1);
          }
        }
        return {
          tag: d,
          semantics: u,
          score: s.scoreElement(h),
          nthChild: g
        };
      }),
      degraded: c,
      degradationReason: c ? "path-depth-overflow" : void 0
    };
  }
  /**
   * Legacy method for backward compatibility
   */
  buildPathNodes(t, e, s) {
    return this.buildPath(t, e, s).path;
  }
  /**
   * Ensures path uniqueness by adding nodes if needed
   * Following SPECIFICATION.md §8 Disambiguation Algorithm
   */
  ensureUniqueness(t, e, s, n, a) {
    const i = this.buildTestSelector(s, e, n);
    try {
      const o = n.ownerDocument;
      if (!o) return e;
      let c;
      if (this.cache) {
        const f = this.cache.getSelectorResults(i);
        f !== void 0 ? c = f : (c = Array.from(o.querySelectorAll(i)), this.cache.setSelectorResults(i, c));
      } else
        c = o.querySelectorAll(i);
      if (c.length <= 1)
        return e;
      const l = t.filter((f) => !e.includes(f));
      for (const f of l) {
        if (a.scoreElement(f) < yt.MIN_CONFIDENCE_FOR_SKIP)
          continue;
        const d = this.insertNodeInOrder(e, f, t), u = this.buildTestSelector(s, d, n);
        try {
          let g;
          if (this.cache) {
            const m = this.cache.getSelectorResults(u);
            m !== void 0 ? g = m : (g = Array.from(o.querySelectorAll(u)), this.cache.setSelectorResults(u, g));
          } else
            g = o.querySelectorAll(u);
          if (g.length === 1)
            return d;
          g.length < c.length && (e = d);
        } catch {
        }
      }
      return e;
    } catch {
      return e;
    }
  }
  /**
   * Inserts node into path maintaining original order
   */
  insertNodeInOrder(t, e, s) {
    const n = s.indexOf(e), a = [...t];
    let i = 0;
    for (let o = 0; o < a.length && !(s.indexOf(a[o]) > n); o++)
      i = o + 1;
    return a.splice(i, 0, e), a;
  }
  /**
   * Builds a test CSS selector from path
   */
  buildTestSelector(t, e, s) {
    const n = [];
    n.push(this.elementToSelector(t));
    for (const a of e)
      n.push(this.elementToSelector(a));
    return n.push(this.elementToSelector(s)), n.join(" ");
  }
  /**
   * Converts element to basic CSS selector
   */
  elementToSelector(t) {
    let e = t.tagName.toLowerCase();
    t.id && !L(t.id) && (e += `#${rt(t.id)}`);
    for (const s of Array.from(t.classList))
      st(s) || (e += `.${rt(s)}`);
    return e;
  }
  /**
   * Filters out noise/layout elements
   */
  filterNoise(t) {
    return t.filter((e) => this.shouldInclude(e));
  }
  /**
   * Determines if element should be included in path
   */
  shouldInclude(t) {
    const e = t.tagName.toLowerCase();
    return St.includes(e) ? !0 : e === "div" || e === "span" ? this.hasSemanticFeatures(t) : !1;
  }
  /**
   * Checks if element has meaningful semantic features
   */
  hasSemanticFeatures(t) {
    if (t.hasAttribute("role")) return !0;
    for (const s of Array.from(t.attributes))
      if (s.name.startsWith("aria-")) return !0;
    if (t.classList.length > 0) {
      for (const s of Array.from(t.classList))
        if (!st(s)) return !0;
    }
    if (t.hasAttribute("data-testid") || t.hasAttribute("data-qa") || t.hasAttribute("data-test"))
      return !0;
    const e = t.id;
    return !!(e && !L(e));
  }
  /**
   * Checks if element is inside <head> section.
   * Stops at <body> to avoid false positives.
   * @param element - Element to check
   * @returns True if element is inside head, false otherwise
   * @remarks
   * Traverses up the DOM tree until finding head or body.
   * Returns false if body is encountered first.
   */
  isInsideHead(t) {
    let e = t.parentElement;
    for (; e; ) {
      const s = e.tagName.toLowerCase();
      if (s === "head") return !0;
      if (s === "body") return !1;
      e = e.parentElement;
    }
    return !1;
  }
  /**
   * Builds path from html to target through head element.
   * Always includes head in the path for correct CSS selector generation.
   * @param htmlElement - The html element (anchor)
   * @param target - Target element inside head
   * @param extractor - Semantic extractor instance
   * @returns Path build result with head and intermediate nodes
   * @example
   * For <html><head><meta name="description"></head></html>
   * Returns path: [head]
   */
  buildHeadPath(t, e, s) {
    const n = [];
    let a = e.parentElement;
    for (; a && a !== t; )
      n.unshift(a), a = a.parentElement;
    return a !== t ? {
      path: [],
      degraded: !0,
      degradationReason: "target-not-descendant-of-html"
    } : n.findIndex((c) => c.tagName.toLowerCase() === "head") === -1 ? {
      path: [],
      degraded: !0,
      degradationReason: "head-not-found-in-path"
    } : {
      path: n.map((c) => {
        const l = c.tagName.toLowerCase(), f = s.extract(c);
        let h;
        if (_(l, f, c)) {
          const d = c.parentElement;
          if (d) {
            const g = Array.from(d.children).indexOf(c);
            g !== -1 && (h = g + 1);
          }
        }
        return {
          tag: l,
          semantics: f,
          score: s.scoreElement(c),
          nthChild: h
        };
      }),
      degraded: !1
    };
  }
}
function j(r) {
  return r ? r.trim().replace(/[\n\t\r]/g, " ").replace(/\s+/g, " ") : "";
}
const kt = {
  preserveQueryForAbsolute: !0,
  removeDynamicHashes: !0
};
function _t(r) {
  return r ? [
    /\d{5,}/,
    // 5+ digits
    /[a-f0-9]{8,}/i,
    // hex hash 8+ characters
    /(session|token|temp|random|timestamp|nonce|cache)/i,
    // dynamic words
    /^\d+$/,
    // only digits
    /^[a-f0-9-]{32,}$/i
    // UUID-like
  ].some((e) => e.test(r)) : !1;
}
function Ot(r, t) {
  if (!r) return r;
  const e = r.startsWith("http://") || r.startsWith("https://"), [s, n] = r.split("#"), [a, i] = s.split("?");
  let o = a;
  return e && t.preserveQueryForAbsolute && i && (o += `?${i}`), n && (t.removeDynamicHashes && _t(n) || (o += `#${n}`)), o;
}
function D(r, t, e = {}) {
  if (!t) return t;
  const s = { ...kt, ...e };
  return r === "href" || r === "src" ? Ot(t, s) : t;
}
const qt = [
  "role",
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-controls",
  "aria-owns",
  "aria-level",
  "aria-posinset",
  "aria-setsize",
  "aria-haspopup"
], Ut = [
  "aria-selected",
  "aria-checked",
  "aria-pressed",
  "aria-expanded",
  "aria-hidden",
  "aria-disabled",
  "aria-current",
  "aria-busy",
  "aria-invalid",
  "aria-grabbed",
  "aria-live",
  "aria-atomic"
], zt = [
  "data-state",
  "data-active",
  "data-inactive",
  "data-selected",
  "data-open",
  "data-closed",
  "data-visible",
  "data-hidden",
  "data-disabled",
  "data-enabled",
  "data-loading",
  "data-error",
  "data-success",
  "data-highlighted",
  "data-focused",
  "data-hover",
  "data-orientation",
  "data-theme"
], Ft = [
  "data-radix-",
  "data-headlessui-",
  "data-reach-",
  "data-mui-",
  "data-chakra-",
  "data-mantine-",
  "data-tw-"
], jt = [
  "data-testid",
  "data-test-id",
  "data-test",
  "data-cy",
  "data-qa",
  "data-automation-id",
  "data-id",
  "data-component",
  "data-entity-id",
  "data-product-id",
  "data-user-id"
], Wt = [
  // Google Analytics / GTM
  "data-ga",
  "data-gtm",
  "data-google",
  "data-layer",
  "data-event",
  // Yandex Metrica
  "data-yandex",
  "data-ym",
  "data-metrika",
  // A/B Testing
  "data-optimizely",
  "data-vwo",
  "data-optimize",
  // Session Recording
  "data-hj",
  "data-hotjar",
  "data-fs",
  "data-mouseflow",
  "data-mf",
  "data-smartlook",
  "data-sl",
  // Social / Ad Pixels
  "data-fb",
  "data-facebook",
  "data-tt",
  "data-li",
  // Generic Tracking
  "data-track",
  "data-tracking",
  "data-click",
  "data-impression",
  "data-conversion",
  "data-segment",
  "data-analytics"
], Bt = [
  "data-category",
  // Google Analytics category
  "data-action",
  // Google Analytics action
  "data-label",
  // Google Analytics label
  "data-value"
  // Google Analytics value
], Gt = [
  "id",
  "name",
  "type",
  "placeholder",
  "title",
  "for",
  "alt",
  "href"
], Vt = [
  "disabled",
  "checked",
  "selected",
  "hidden",
  "readonly",
  "required",
  "value"
], Qt = [
  /^radix-/,
  /^headlessui-/,
  /^mui-/,
  /:\w+:/
  // matches :ru:, :r1:, etc.
];
function Yt(r, t) {
  return qt.includes(r) ? !0 : Ut.includes(r) || zt.includes(r) || Ft.some((e) => r.startsWith(e)) ? !1 : jt.includes(r) ? !0 : Wt.some((e) => r.startsWith(e)) || Bt.includes(r) ? !1 : r.startsWith("data-") && r.endsWith("-id") ? !0 : r === "id" ? !Qt.some((e) => e.test(t)) : Gt.includes(r) ? !0 : Vt.includes(r) ? !1 : !!r.startsWith("data-");
}
class nt {
  constructor(t, e) {
    this.includeUtilityClasses = t.includeUtilityClasses ?? !1, this.cache = e;
  }
  /**
   * Extracts semantic features from element
   * @param element - DOM element to extract from
   * @returns Semantic features object
   */
  extract(t) {
    if (this.cache) {
      const i = this.cache.getSemantics(t);
      if (i !== void 0)
        return i;
    }
    const e = {}, s = t.id;
    if (s && !L(s) && (e.id = s), t.classList.length > 0) {
      const i = Array.from(t.classList);
      if (this.includeUtilityClasses)
        e.classes = i;
      else {
        const { semantic: o } = Rt(i);
        o.length > 0 && (e.classes = o);
      }
    }
    const n = this.extractAttributes(t);
    Object.keys(n).length > 0 && (e.attributes = n);
    const a = t.getAttribute("role");
    if (a && (e.role = a), this.shouldExtractText(t)) {
      const i = this.extractText(t);
      i && (e.text = i);
    }
    return this.cache && this.cache.setSemantics(t, e), e;
  }
  /**
   * Scores element based on semantic richness
   * @param element - Element to score
   * @returns Score from 0 to 1
   */
  scoreElement(t) {
    let e = 0.5;
    const s = this.extract(t);
    return s.id && (e += 0.15), s.classes && s.classes.length > 0 && (e += 0.1), s.attributes && Object.keys(s.attributes).length > 0 && (e += 0.1), s.role && (e += 0.1), s.text && (e += 0.05), Math.min(e, 1);
  }
  /**
   * Checks if attribute should be ignored
   * @param attrName - Attribute name
   * @returns True if should be ignored
   */
  shouldIgnoreAttribute(t) {
    return !!(Y.has(t) || t.startsWith("on") || t.startsWith("ng-") || t.startsWith("_ng") || t.startsWith("data-reactid") || t.startsWith("data-react") || t.startsWith("data-v-"));
  }
  /**
   * Gets attribute priority
   * @param attrName - Attribute name
   * @returns Priority number (higher = more priority)
   */
  getAttributePriority(t) {
    return w[t] !== void 0 ? w[t] : t.startsWith("data-") ? w["data-*"] : t.startsWith("aria-") ? w["aria-*"] : 0;
  }
  /**
   * Checks if attribute value is dynamic (should be ignored)
   * @param value - Attribute value
   * @returns True if value is dynamic
   */
  isDynamicValue(t) {
    return [
      /^[a-f0-9]{32,}$/i,
      // Long hashes
      /^\d{10,}$/,
      // Timestamp
      /^(undefined|null|\[object)/,
      // JS artifacts
      /^{{.*}}$/
      // Template literals
    ].some((s) => s.test(t));
  }
  /**
   * Extracts relevant semantic attributes from element
   * Iterates through all attributes and filters by priority
   */
  extractAttributes(t) {
    const e = {};
    for (const s of Array.from(t.attributes)) {
      const n = s.name;
      if (this.shouldIgnoreAttribute(n) || !Yt(n, s.value) || Z.has(n) && K(s.value) || this.getAttributePriority(n) === 0) continue;
      const i = n === "href" || n === "src" ? D(n, s.value) : s.value;
      !i || i.trim() === "" || this.isDynamicValue(i) || (e[n] = i);
    }
    return e;
  }
  /**
   * Extracts and normalizes text content
   */
  extractText(t) {
    const e = this.getDirectTextContent(t);
    if (!e) return null;
    const s = j(e);
    if (!s) return null;
    const n = 100, a = e.length > n ? e.slice(0, n) + "..." : e, i = s.length > n ? s.slice(0, n) + "..." : s;
    return {
      raw: a,
      normalized: i
    };
  }
  /**
   * Gets direct text content excluding child elements
   */
  getDirectTextContent(t) {
    const e = [];
    for (const s of Array.from(t.childNodes))
      if (s.nodeType === Node.TEXT_NODE && s.textContent) {
        const n = s.textContent.trim();
        n && e.push(n);
      }
    return e.length > 0 ? e.join(" ") : t.textContent ?? null;
  }
  /**
   * Determines if text should be extracted for this element
   */
  shouldExtractText(t) {
    const e = t.tagName.toLowerCase();
    return [
      "button",
      "a",
      "label",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "p",
      "span",
      "li",
      "th",
      "td",
      "dt",
      "dd",
      "legend",
      "figcaption",
      "summary"
    ].includes(e);
  }
}
class Zt {
  /**
   * Generates fingerprint for SVG element
   * @param element - SVG element to fingerprint
   * @returns SVG fingerprint object
   */
  fingerprint(t) {
    const e = t.tagName.toLowerCase(), s = this.getShape(e), n = {
      shape: s,
      hasAnimation: this.hasAnimation(t)
    };
    if (s === "path") {
      const o = t.getAttribute("d");
      o && (n.dHash = this.computePathHash(o));
    } else ["circle", "rect", "ellipse", "line"].includes(s) && (n.geomHash = this.computeGeomHash(t, s));
    const a = t.getAttribute("role");
    a && (n.role = a);
    const i = t.querySelector("title");
    return i?.textContent && (n.titleText = i.textContent.trim()), n;
  }
  /**
   * Computes hash from path data (first N commands)
   * @param d - SVG path d attribute value
   * @returns Hash string
   */
  computePathHash(t) {
    const e = this.normalizePathData(t);
    return this.simpleHash(e);
  }
  /**
   * Gets the shape type from tag name
   */
  getShape(t) {
    return [
      "path",
      "circle",
      "rect",
      "line",
      "polyline",
      "polygon",
      "ellipse",
      "g",
      "text",
      "use",
      "svg"
    ].find((s) => s === t) ?? "path";
  }
  /**
   * Normalizes path data for consistent hashing
   */
  normalizePathData(t) {
    return (t.match(/[MLHVCSQTAZ][^MLHVCSQTAZ]*/gi) ?? []).slice(0, 5).map((n) => n.trim().replace(/(-?\d+\.?\d*)/g, (a) => parseFloat(a).toFixed(1))).join(" ");
  }
  /**
   * Computes geometry hash for non-path shapes
   */
  computeGeomHash(t, e) {
    const s = [];
    switch (e) {
      case "circle":
        s.push(`r=${t.getAttribute("r") ?? "0"}`);
        break;
      case "rect":
        {
          const n = parseFloat(t.getAttribute("width") ?? "0"), a = parseFloat(t.getAttribute("height") ?? "0");
          n > 0 && a > 0 && s.push(`ratio=${(n / a).toFixed(2)}`);
        }
        break;
      case "ellipse":
        {
          const n = parseFloat(t.getAttribute("rx") ?? "0"), a = parseFloat(t.getAttribute("ry") ?? "0");
          n > 0 && a > 0 && s.push(`ratio=${(n / a).toFixed(2)}`);
        }
        break;
      case "line":
        {
          const n = parseFloat(t.getAttribute("x1") ?? "0"), a = parseFloat(t.getAttribute("y1") ?? "0"), i = parseFloat(t.getAttribute("x2") ?? "0"), o = parseFloat(t.getAttribute("y2") ?? "0"), c = Math.atan2(o - a, i - n);
          s.push(`angle=${c.toFixed(2)}`);
        }
        break;
    }
    return this.simpleHash(s.join(";"));
  }
  /**
   * Detects animations on SVG element
   */
  hasAnimation(t) {
    if (t.querySelector("animate, animateTransform, animateMotion"))
      return !0;
    const e = t.ownerDocument;
    if (e?.defaultView)
      try {
        const s = e.defaultView.getComputedStyle(t);
        if (s.animationName !== "none" || s.transitionProperty !== "all" && s.transitionProperty !== "none")
          return !0;
      } catch {
      }
    return !1;
  }
  /**
   * Simple hash function for fingerprinting (not cryptographic)
   */
  simpleHash(t) {
    let e = 0;
    for (let s = 0; s < t.length; s++) {
      const n = t.charCodeAt(s);
      e = (e << 5) - e + n, e = e & e;
    }
    return Math.abs(e).toString(16).padStart(8, "0");
  }
}
function Kt(r, t = 0) {
  const e = r.anchor.score, s = r.path.length > 0 ? r.path.reduce((o, c) => o + c.score, 0) / r.path.length : 0.5, n = r.target.score, a = e * z.ANCHOR + s * z.PATH + n * z.TARGET + t * z.UNIQUENESS, i = r.anchor.degraded ? 0.2 : 0;
  return Math.max(0, Math.min(1, a - i));
}
function we(r, t, e) {
  let s = 0.5;
  return t && (s += 0.2), e && (s += 0.15), s += Math.min(r * 0.05, 0.15), Math.min(s, 1);
}
class Xt {
  constructor(t) {
    this.cache = /* @__PURE__ */ new Map(), this.maxSize = t;
  }
  get(t) {
    const e = this.cache.get(t);
    if (e !== void 0)
      return this.cache.delete(t), this.cache.set(t, e), e;
  }
  set(t, e) {
    if (this.cache.has(t))
      this.cache.delete(t);
    else if (this.cache.size >= this.maxSize) {
      const s = this.cache.keys().next().value;
      s !== void 0 && this.cache.delete(s);
    }
    this.cache.set(t, e);
  }
  has(t) {
    return this.cache.has(t);
  }
  delete(t) {
    this.cache.delete(t);
  }
  clear() {
    this.cache.clear();
  }
  get size() {
    return this.cache.size;
  }
}
class Jt {
  constructor(t = {}) {
    this.eidCache = /* @__PURE__ */ new WeakMap(), this.selectorResultCache = new Xt(
      t.maxSelectorCacheSize ?? 1e3
    ), this.anchorCache = /* @__PURE__ */ new WeakMap(), this.semanticsCache = /* @__PURE__ */ new WeakMap(), this.stats = {
      eidHits: 0,
      eidMisses: 0,
      selectorHits: 0,
      selectorMisses: 0,
      anchorHits: 0,
      anchorMisses: 0,
      semanticsHits: 0,
      semanticsMisses: 0,
      selectorCacheSize: 0,
      maxSelectorCacheSize: t.maxSelectorCacheSize ?? 1e3
    };
  }
  /**
   * Get cached EID for element
   */
  getEID(t) {
    const e = this.eidCache.get(t);
    if (e !== void 0)
      return this.stats.eidHits++, e;
    this.stats.eidMisses++;
  }
  /**
   * Cache EID for element
   */
  setEID(t, e) {
    this.eidCache.set(t, e);
  }
  /**
   * Get cached selector results
   */
  getSelectorResults(t) {
    const e = this.selectorResultCache.get(t);
    if (e !== void 0)
      return this.stats.selectorHits++, this.stats.selectorCacheSize = this.selectorResultCache.size, e;
    this.stats.selectorMisses++, this.stats.selectorCacheSize = this.selectorResultCache.size;
  }
  /**
   * Cache selector results
   */
  setSelectorResults(t, e) {
    this.selectorResultCache.set(t, e), this.stats.selectorCacheSize = this.selectorResultCache.size;
  }
  /**
   * Get cached anchor result
   */
  getAnchor(t) {
    if (this.anchorCache.has(t))
      return this.stats.anchorHits++, this.anchorCache.get(t);
    this.stats.anchorMisses++;
  }
  /**
   * Cache anchor result
   */
  setAnchor(t, e) {
    this.anchorCache.set(t, e);
  }
  /**
   * Get cached semantics
   */
  getSemantics(t) {
    const e = this.semanticsCache.get(t);
    if (e !== void 0)
      return this.stats.semanticsHits++, e;
    this.stats.semanticsMisses++;
  }
  /**
   * Cache semantics
   */
  setSemantics(t, e) {
    this.semanticsCache.set(t, e);
  }
  /**
   * Clear all caches
   */
  clear() {
    this.selectorResultCache.clear(), this.stats.selectorCacheSize = 0, this.stats = {
      eidHits: 0,
      eidMisses: 0,
      selectorHits: 0,
      selectorMisses: 0,
      anchorHits: 0,
      anchorMisses: 0,
      semanticsHits: 0,
      semanticsMisses: 0,
      selectorCacheSize: 0,
      maxSelectorCacheSize: this.stats.maxSelectorCacheSize
    };
  }
  /**
   * Invalidate cache for a specific element
   * Note: WeakMaps don't support deletion, but we can clear selector cache
   * if needed. This method is mainly for future extensibility.
   */
  invalidateElement(t) {
  }
  /**
   * Invalidate a specific selector from cache
   */
  invalidateSelector(t) {
    this.selectorResultCache.delete(t), this.stats.selectorCacheSize = this.selectorResultCache.size;
  }
  /**
   * Get cache statistics
   */
  getStats() {
    return {
      ...this.stats,
      selectorCacheSize: this.selectorResultCache.size
    };
  }
  /**
   * Get cache hit rate for EID cache
   */
  getEIDHitRate() {
    const t = this.stats.eidHits + this.stats.eidMisses;
    return t > 0 ? this.stats.eidHits / t : 0;
  }
  /**
   * Get cache hit rate for selector cache
   */
  getSelectorHitRate() {
    const t = this.stats.selectorHits + this.stats.selectorMisses;
    return t > 0 ? this.stats.selectorHits / t : 0;
  }
  /**
   * Get cache hit rate for anchor cache
   */
  getAnchorHitRate() {
    const t = this.stats.anchorHits + this.stats.anchorMisses;
    return t > 0 ? this.stats.anchorHits / t : 0;
  }
  /**
   * Get cache hit rate for semantics cache
   */
  getSemanticsHitRate() {
    const t = this.stats.semanticsHits + this.stats.semanticsMisses;
    return t > 0 ? this.stats.semanticsHits / t : 0;
  }
  /**
   * Get overall cache hit rate
   */
  getOverallHitRate() {
    const t = this.stats.eidHits + this.stats.selectorHits + this.stats.anchorHits + this.stats.semanticsHits, e = this.stats.eidMisses + this.stats.selectorMisses + this.stats.anchorMisses + this.stats.semanticsMisses, s = t + e;
    return s > 0 ? t / s : 0;
  }
}
function te(r) {
  return new Jt(r);
}
let F = null;
function X() {
  return F || (F = te()), F;
}
function ve() {
  F = null;
}
function k(r) {
  if (r.ownerDocument)
    return r.ownerDocument;
  let t = r;
  for (; t; ) {
    if (t.nodeType === 9)
      return t;
    t = t.parentNode;
  }
  throw new Error(
    `Element does not have an ownerDocument. This typically means:
1. The element is detached from the DOM
2. The element was created but never attached
3. You are working with a document node instead of an element`
  );
}
function ee(r, t) {
  if (!t)
    return;
  const e = k(r), s = t instanceof Document ? t : k(t);
  if (e !== s)
    throw new Error(
      `Cross-document operation detected: element and root are from different documents.
Common causes:
1. Working with iframe: pass iframe.contentDocument as root parameter
2. Element from one iframe, root from another
3. Element from main document, root from iframe (or vice versa)

Solution: Ensure element and root parameter are from the same document context.`
    );
}
function J(r, t = {}) {
  if (!r || !r.ownerDocument || !r.isConnected)
    return null;
  const e = { ...xt, ...t };
  if (e.root)
    try {
      ee(r, e.root);
    } catch (x) {
      return console.error("Cross-document generation detected:", x), null;
    }
  const s = e.cache ?? X(), n = s.getEID(r);
  if (n !== void 0)
    return n;
  const a = r.tagName.toLowerCase();
  if (a === "html") {
    const x = new nt(e, s), S = ne(r, e, x);
    return s.setEID(r, S), S;
  }
  const i = new Tt(e, s), o = new Ht(e, s), c = new nt(e, s), l = new Zt(), f = i.findAnchor(r);
  if (!f && !e.fallbackToBody)
    return null;
  const h = f?.element ?? r.ownerDocument?.body ?? null;
  if (!h) return null;
  const d = !f || f.tier === "C", u = h.tagName.toLowerCase(), g = c.extract(h), m = h.parentElement;
  let p;
  if (m && u !== "body" && u !== "html" && _(u, g, h)) {
    const S = Array.from(m.children).indexOf(h);
    S !== -1 && (p = S + 1);
  }
  const b = {
    tag: h.tagName.toLowerCase(),
    semantics: g,
    score: f?.score ?? I.DEGRADED_SCORE,
    degraded: d,
    nthChild: p
  }, y = o.buildPath(h, r, c), T = c.extract(r);
  e.enableSvgFingerprint && se(r) && (T.svg = l.fingerprint(r));
  const C = r.parentElement;
  let A;
  if (C && _(a, T, r)) {
    const S = Array.from(C.children).indexOf(r);
    S !== -1 && (A = S + 1);
  }
  const v = {
    tag: r.tagName.toLowerCase(),
    semantics: T,
    score: c.scoreElement(r),
    nthChild: A
  }, P = [], $ = {
    onMultiple: "best-score",
    onMissing: "anchor-only",
    maxDepth: 3
  }, E = b.degraded || y.degraded, R = re(b.degraded, y), N = {
    version: "1.0",
    anchor: b,
    path: y.path,
    target: v,
    constraints: P,
    fallback: $,
    meta: {
      confidence: 0,
      // Calculated below
      generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
      generator: "dom-eid@1.0",
      source: e.source,
      degraded: E,
      degradationReason: R
    }
  };
  return N.meta.confidence = Kt(N), N.meta.confidence < e.confidenceThreshold ? null : (s.setEID(r, N), N);
}
function se(r) {
  return r.namespaceURI === "http://www.w3.org/2000/svg" || r.tagName.toLowerCase() === "svg" || r instanceof SVGElement;
}
function re(r, t) {
  if (r && t.degraded)
    return "anchor-and-path-degraded";
  if (r)
    return "no-semantic-anchor";
  if (t.degraded)
    return t.degradationReason;
}
function ne(r, t, e, s) {
  const a = {
    tag: "html",
    semantics: e.extract(r),
    score: 1,
    degraded: !1,
    nthChild: void 0
  };
  return {
    version: "1.0",
    anchor: a,
    path: [],
    target: a,
    constraints: [],
    fallback: {
      onMultiple: "best-score",
      onMissing: "anchor-only",
      maxDepth: 3
    },
    meta: {
      confidence: 1,
      generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
      generator: "dom-eid@1.0",
      source: t.source,
      degraded: !1,
      degradationReason: void 0
    }
  };
}
class ht {
  buildSelector(t, e) {
    if (t.target.tag === "html") {
      const h = "html";
      return e?.ensureUnique ? {
        selector: h,
        isUnique: !0,
        usedNthOfType: !1,
        extraClassesAdded: 0
      } : h;
    }
    if (t.anchor.tag === "html" && t.path.length === 0) {
      const d = `html > ${this.buildNodeSelector(t.target.tag, t.target.semantics)}`;
      return e?.ensureUnique ? {
        selector: d,
        isUnique: this.isUnique(d, e.root ?? document),
        usedNthOfType: !1,
        extraClassesAdded: 0
      } : d;
    }
    if (t.anchor.tag === "html" && t.path.length > 0 && t.path[0].tag === "head")
      return this.buildHeadSelector(t, e);
    if (t.path.length === 0 && t.anchor.tag === t.target.tag && JSON.stringify(t.anchor.semantics) === JSON.stringify(t.target.semantics)) {
      const h = this.buildNodeSelector(
        t.target.tag,
        t.target.semantics,
        { excludeClasses: !1 }
        // Include classes for same-element case
      );
      return e?.ensureUnique ? this.ensureUniqueSelector(h, t, e) : h;
    }
    const n = [], a = e?.ensureUnique ? this.ensureUniqueAnchor(t, e.root) : this.buildNodeSelector(t.anchor.tag, t.anchor.semantics);
    n.push(a);
    for (const h of t.path) {
      let d = this.buildNodeSelector(h.tag, h.semantics);
      h.nthChild !== void 0 && _(h.tag, h.semantics) && (d += `:nth-child(${h.nthChild})`), n.push(d);
    }
    let i = this.buildNodeSelector(
      t.target.tag,
      t.target.semantics,
      { excludeClasses: e?.ensureUnique }
      // Exclude classes initially if we need unique
    );
    t.target.nthChild !== void 0 && _(t.target.tag, t.target.semantics) && (i += `:nth-child(${t.target.nthChild})`), n.push(i);
    const o = this.isSvgChildElement(t.target.tag), c = t.path.some((h) => h.tag === "svg");
    let l;
    if (o && c) {
      const h = t.path.findIndex((d) => d.tag === "svg");
      if (h !== -1) {
        const d = h + 1, u = n.slice(0, d + 1), g = n.slice(d + 1, -1), m = n[n.length - 1];
        g.length > 0 ? l = u.join(" ") + " > " + g.join(" > ") + " > " + m : l = u.join(" ") + " > " + m;
      } else
        l = n.join(" ");
    } else
      l = n.join(" ");
    if (!e?.ensureUnique)
      return l;
    const f = this.querySelectorSafe(l, e.root ?? document);
    if (f.length === 1)
      return {
        selector: l,
        isUnique: !0,
        usedNthOfType: l.includes(":nth-"),
        extraClassesAdded: 0
      };
    if (f.length === 0 || f.length > 1) {
      const h = this.buildFullDomPathSelector(
        t,
        t.target.semantics,
        e.root ?? document
      );
      if (h && this.isUnique(h, e.root ?? document))
        return {
          selector: h,
          isUnique: !0,
          usedNthOfType: h.includes(":nth-"),
          extraClassesAdded: 0
        };
    }
    return this.ensureUniqueSelector(l, t, e);
  }
  /**
   * Builds selector for anchor only (used in fallback)
   * @param eid - Element Identity
   * @returns CSS selector for anchor
   */
  buildAnchorSelector(t) {
    return this.buildNodeSelector(t.anchor.tag, t.anchor.semantics);
  }
  /**
   * Ensures selector uniqueness by progressively adding classes and nth-of-type
   */
  ensureUniqueSelector(t, e, s) {
    const n = s.root ?? document, a = s.maxClasses ?? 4, i = e.target.tag, o = e.target.semantics;
    let c = t, l = 0, f = !1;
    if (this.querySelectorSafe(c, n).length === 0) {
      const g = this.buildFullDomPathSelector(e, o, n);
      if (g && (c = g, this.isUnique(c, n)))
        return {
          selector: c,
          isUnique: !0,
          usedNthOfType: !1,
          extraClassesAdded: 0
        };
    }
    if (this.isUnique(c, n))
      return {
        selector: c,
        isUnique: !0,
        usedNthOfType: !1,
        extraClassesAdded: 0
      };
    const d = M(o.classes ?? []);
    for (let g = 0; g < Math.min(d.length, a); g++) {
      const m = d[g];
      if (c += `.${this.escapeCSS(m)}`, l++, this.isUnique(c, n))
        return {
          selector: c,
          isUnique: !0,
          usedNthOfType: !1,
          extraClassesAdded: l
        };
    }
    if (!this.isUnique(c, n)) {
      const g = this.buildFullDomPathSelector(e, o, n);
      if (g && this.isUnique(g, n))
        return {
          selector: g,
          isUnique: !0,
          usedNthOfType: g.includes(":nth-of-type("),
          extraClassesAdded: l
        };
    }
    const u = this.findNthElementByText(c, o, n);
    return u && (c += this.getNthSelector(u, i), f = !0), {
      selector: c,
      isUnique: this.isUnique(c, n),
      usedNthOfType: f,
      extraClassesAdded: l
    };
  }
  /**
   * Builds full DOM path selector by traversing actual DOM from anchor
   * This handles cases where intermediate div/span elements were filtered out
   */
  buildFullDomPathSelector(t, e, s) {
    const n = this.buildNodeSelector(t.anchor.tag, t.anchor.semantics), a = this.querySelectorSafe(n, s);
    if (a.length === 0) return null;
    for (const i of a) {
      const o = this.findTargetWithinAnchor(i, t.target.tag, e);
      if (o.length === 0) continue;
      const c = o.map((l) => {
        const f = this.scorePathMatch(l, i, t.path);
        return { element: l, score: f };
      });
      c.sort((l, f) => f.score - l.score);
      for (const { element: l } of c) {
        const f = this.buildPathFromAnchorToTarget(i, l, t, s);
        if (f && this.isUnique(f, s))
          return f;
      }
    }
    return null;
  }
  /**
   * Scores how well a candidate's DOM path matches the EID path
   * Compares tags, classes, attributes, and nthChild positions
   * @param candidate - Target element candidate
   * @param anchor - Anchor element
   * @param eidPath - EID path nodes
   * @returns Score (higher = better match)
   */
  scorePathMatch(t, e, s) {
    const n = [];
    let a = t.parentElement;
    for (; a && a !== e; )
      n.unshift(a), a = a.parentElement;
    let i = 0;
    const o = Math.min(n.length, s.length);
    for (let l = 0; l < o; l++) {
      const f = n[l], h = s[l];
      if (f.tagName.toLowerCase() === h.tag) {
        if (i += 10, h.nthChild !== void 0) {
          const d = f.parentElement;
          d && (Array.from(d.children).indexOf(f) + 1 === h.nthChild ? i += 20 : i -= 10);
        }
      } else
        i -= 5;
      if (h.semantics.classes && h.semantics.classes.length > 0) {
        const d = h.semantics.classes.filter(
          (u) => f.classList.contains(u)
        );
        i += d.length * 2;
      }
      if (h.semantics.attributes) {
        const d = Object.entries(h.semantics.attributes).filter(
          ([u, g]) => f.getAttribute(u) === g
        );
        i += d.length * 3;
      }
    }
    const c = Math.abs(n.length - s.length);
    return i -= c * 2, i;
  }
  /**
   * Finds target elements within an anchor by matching semantics
   */
  findTargetWithinAnchor(t, e, s) {
    return Array.from(t.querySelectorAll(e)).filter((a) => {
      if (s.text) {
        const i = a.textContent?.trim() || "", o = s.text.normalized;
        if (!i.includes(o) && !o.includes(i))
          return !1;
      }
      return !!(s.classes && s.classes.length > 0 && s.classes.every((o) => a.classList.contains(o)) || s.attributes && Object.entries(s.attributes).every(([o, c]) => {
        const l = a.getAttribute(o);
        return o === "href" || o === "src" ? D(o, l || "") === D(o, c) : l === c;
      }) || s.text);
    });
  }
  /**
   * Disambiguates a parent element by trying attributes, classes, then nth-of-type
   * Priority: stable attributes > one stable class > nth-of-type
   * @param element The DOM element to disambiguate
   * @param tag The tag name
   * @param pathNode EID path node with semantics (if available)
   * @param fullPath Current selector path (for uniqueness testing)
   * @param root Root element for queries
   * @returns Disambiguated selector part (e.g., "div[role='main']" or "div.sidebar" or "div:nth-of-type(3)")
   */
  disambiguateParent(t, e, s, n, a) {
    if (s?.semantics?.attributes) {
      const o = this.buildNodeSelector(e, s.semantics, {
        excludeClasses: !0
      }), c = [...n, e].join(" > "), l = this.querySelectorSafe(c, a), f = [...n, o].join(" > "), h = this.querySelectorSafe(f, a);
      if (h.length > 0 && h.length < l.length)
        return o;
    }
    if (s?.semantics?.classes) {
      const o = M(s.semantics.classes);
      if (o.length > 0) {
        const c = `${e}.${this.escapeCSS(o[0])}`, l = [...n, e].join(" > "), f = this.querySelectorSafe(l, a), h = [...n, c].join(" > "), d = this.querySelectorSafe(h, a);
        if (d.length > 0 && d.length < f.length)
          return c;
      }
    }
    const i = t.parentElement;
    return i && Array.from(i.children).filter((c) => c.tagName.toLowerCase() === e).length > 1 ? `${e}${this.getNthSelector(t, e)}` : e;
  }
  /**
   * Builds CSS selector path from anchor to target by traversing actual DOM
   */
  buildPathFromAnchorToTarget(t, e, s, n) {
    const a = [];
    let i = e;
    for (; i && i !== t; )
      a.unshift(i), i = i.parentElement;
    if (i !== t)
      return null;
    const o = [
      // ============================================================
      // Strategy 0: anchor path target[attrs_only]
      // Most flexible - no classes on target, only semantic attributes
      // ============================================================
      () => {
        const c = this.buildNodeSelector(s.anchor.tag, s.anchor.semantics), l = s.target.tag, f = s.target.semantics, h = [];
        for (const p of s.path)
          h.push(p.tag);
        const u = [c, ...h, l].filter(Boolean).join(" ");
        if (this.isUnique(u, n))
          return u;
        const g = this.buildNodeSelector(l, f, {
          excludeClasses: !0
          // KEY: no classes on target in Strategy 0
        }), m = [
          c,
          ...h.slice(0, -1),
          g
        ].join(" ");
        return this.isUnique(m, n) ? m : null;
      },
      // ============================================================
      // Strategy 1: anchor > parent[attrs|class|nth] > target[attrs_only]
      // Full path with '>' combinator
      // Parents: disambiguated using attrs > stable class > nth-of-type
      // Target: ONLY attributes, NO classes
      // ============================================================
      () => {
        const c = [this.buildNodeSelector(s.anchor.tag, s.anchor.semantics)], l = /* @__PURE__ */ new Map();
        let f = 0;
        for (let d = 0; d < a.length - 1; d++) {
          const u = a[d], g = u.tagName.toLowerCase();
          f < s.path.length && s.path[f].tag === g ? (l.set(u, s.path[f]), f++) : l.set(u, null);
        }
        for (let d = 0; d < a.length; d++) {
          const u = a[d], g = u.tagName.toLowerCase();
          if (d < a.length - 1) {
            const b = l.get(u) || null, y = this.disambiguateParent(u, g, b, c, n);
            c.push(y);
            continue;
          }
          const m = this.buildNodeSelector(
            s.target.tag,
            s.target.semantics,
            { excludeClasses: !0 }
            // KEY: no classes on target
          ), p = u.parentElement;
          p && ["td", "th", "tr", "thead", "tbody", "tfoot"].includes(g) && Array.from(p.children).filter(
            (y) => y.tagName.toLowerCase() === g
          ).length > 1 ? c.push(`${m}${this.getNthSelector(u, g)}`) : c.push(m);
        }
        const h = c.join(" > ");
        return this.isUnique(h, n) ? h : null;
      },
      // ============================================================
      // Strategy 2: anchor parent[attrs|class|nth] target[attrs_only]
      // Descendant combinator (space) - more flexible
      // Parents: disambiguated using attrs > stable class > nth-of-type
      // Target: ONLY attributes, NO classes
      // ============================================================
      () => {
        const l = [this.buildNodeSelector(s.anchor.tag, s.anchor.semantics)];
        for (let d = 0; d < a.length - 1; d++) {
          const g = a[d].tagName.toLowerCase(), m = s.path[d] || null, p = l.join(" ") + " " + g;
          if (this.querySelectorSafe(p, n).length > 1) {
            if (m?.semantics?.attributes) {
              const C = this.buildNodeSelector(g, m.semantics, {
                excludeClasses: !0
              }), A = l.join(" ") + " " + C;
              if (this.querySelectorSafe(A, n).length === 1 || this.querySelectorSafe(A + " " + s.target.tag, n).length === 1) {
                l.push(C);
                continue;
              }
            }
            if (m?.semantics?.classes) {
              const C = M(m.semantics.classes);
              if (C.length > 0) {
                const A = `${g}.${this.escapeCSS(C[0])}`, v = l.join(" ") + " " + A;
                if (this.querySelectorSafe(v, n).length === 1 || this.querySelectorSafe(v + " " + s.target.tag, n).length === 1) {
                  l.push(A);
                  continue;
                }
              }
            }
            const y = a[d], T = y.parentElement;
            if (T && Array.from(T.children).filter(
              (A) => A.tagName.toLowerCase() === g
            ).length > 1) {
              l.push(`${g}${this.getNthSelector(y, g)}`);
              continue;
            }
          }
          l.push(g);
        }
        const f = this.buildNodeSelector(
          s.target.tag,
          s.target.semantics,
          { excludeClasses: !0 }
          // KEY: no classes on target
        );
        l.push(f);
        const h = l.join(" ");
        return this.isUnique(h, n) ? h : null;
      },
      // ============================================================
      // Strategy 3: anchor path target[attrs + 1_stable_class]
      // Add ONE stable class to target (must be semantic, NOT utility)
      // Only use this if attrs alone are not sufficient
      // ============================================================
      () => {
        const c = this.buildNodeSelector(s.anchor.tag, s.anchor.semantics), l = [];
        for (const u of s.path)
          l.push(u.tag);
        if (M(s.target.semantics.classes ?? []).length === 0)
          return null;
        const h = this.buildNodeSelector(
          s.target.tag,
          s.target.semantics,
          { maxClasses: 1 }
          // KEY: ONE stable class only
        ), d = [c, ...l.slice(0, -1), h].join(" ");
        return this.isUnique(d, n) ? d : null;
      },
      // ============================================================
      // Strategy 4: anchor path target[attrs]:nth-of-type(N)
      // Last resort - add nth-of-type to target
      // Only use when all other strategies fail
      // ============================================================
      () => {
        const c = this.buildNodeSelector(s.anchor.tag, s.anchor.semantics), l = [];
        for (const m of s.path)
          l.push(m.tag);
        const f = a[a.length - 1], h = f.parentElement;
        if (!h || Array.from(h.children).filter(
          (m) => m.tagName.toLowerCase() === s.target.tag
        ).length <= 1) return null;
        const u = this.buildNodeSelector(
          s.target.tag,
          s.target.semantics,
          { excludeClasses: !0 }
          // No classes, just attrs + nth
        ) + this.getNthSelector(f, s.target.tag), g = [c, ...l.slice(0, -1), u].join(" ");
        return this.isUnique(g, n) ? g : null;
      }
    ];
    for (const c of o) {
      const l = c();
      if (l) return l;
    }
    return null;
  }
  /**
   * Builds a minimal selector for a DOM element
   * @param element The DOM element to create a selector for
   * @returns A minimal CSS selector for the element
   */
  buildElementSelector(t) {
    const e = t.tagName.toLowerCase();
    let s = e;
    if (t.id && !L(t.id))
      return `${e}#${this.escapeCSS(t.id)}`;
    const n = Array.from(t.classList), a = M(n);
    a.length > 0 && (s += a.slice(0, 2).map((o) => `.${this.escapeCSS(o)}`).join(""));
    const i = t.getAttribute("role");
    return i && (s += `[role="${this.escapeAttr(i)}"]`), s;
  }
  /**
   * Safe querySelectorAll that doesn't throw
   */
  querySelectorSafe(t, e) {
    try {
      return Array.from(e.querySelectorAll(t));
    } catch {
      return [];
    }
  }
  /**
   * Finds element by matching text content
   * Returns the matching element (used with getNthSelector for table-aware positioning)
   */
  findNthElementByText(t, e, s) {
    const n = this.querySelectorSafe(t, s);
    if (n.length <= 1) return null;
    if (e.text) {
      const a = e.text.normalized;
      for (const i of n) {
        const o = i.textContent?.trim() || "";
        if (o === a || o.includes(a) || a.includes(o))
          return i;
      }
    }
    return null;
  }
  /**
   * Checks if selector matches exactly one element
   */
  isUnique(t, e) {
    try {
      return e.querySelectorAll(t).length === 1;
    } catch {
      return !1;
    }
  }
  /**
   * Gets nth-of-type index for an element
   */
  getNthOfTypeIndex(t, e) {
    const s = t.parentElement;
    if (!s) return null;
    const a = Array.from(s.children).filter((i) => i.tagName.toLowerCase() === e).indexOf(t);
    return a !== -1 ? a + 1 : null;
  }
  /**
   * FIX 2: Ensures anchor selector is unique in the document
   * Priority order: tag → tag.class → tag[attr] → tag:nth-of-type(N)
   * @param eid - Element Identity with anchor information
   * @param root - Root element for uniqueness check
   * @returns Unique selector for anchor
   */
  ensureUniqueAnchor(t, e) {
    const s = t.anchor.tag, n = t.anchor.semantics;
    if (this.isUnique(s, e))
      return s;
    if (n.classes && n.classes.length > 0) {
      const i = M(n.classes);
      if (i.length > 0) {
        const o = `${s}.${this.escapeCSS(i[0])}`;
        if (this.isUnique(o, e))
          return o;
      }
    }
    if (n.attributes) {
      const i = this.getSortedAttributes(n.attributes);
      for (const { name: o, value: c } of i) {
        const l = o === "href" || o === "src" ? D(o, c) : c;
        if (l) {
          const f = `${s}[${o}="${this.escapeAttr(l)}"]`;
          if (this.isUnique(f, e))
            return f;
        }
      }
    }
    if (t.anchor.nthChild !== void 0) {
      const i = `${s}:nth-child(${t.anchor.nthChild})`;
      if (this.isUnique(i, e))
        return i;
    }
    const a = Array.from(e.querySelectorAll(s));
    if (a.length > 1) {
      const i = this.findElementBySemantics(a, n);
      if (i) {
        const o = this.getNthOfTypeIndex(i, s);
        if (o)
          return `${s}:nth-of-type(${o})`;
      }
    }
    return s;
  }
  /**
   * FIX 2: Finds element by matching semantics
   * @param elements - Array of candidate elements
   * @param semantics - Semantics to match against
   * @returns Matching element or null
   */
  findElementBySemantics(t, e) {
    return e.classes && e.classes.length > 0 || e.attributes && Object.keys(e.attributes).length > 0 || e.text ? t.find((n) => {
      if (e.classes && e.classes.length > 0 && e.classes.every((i) => n.classList.contains(i)) || e.attributes && Object.entries(e.attributes).every(
        ([i, o]) => n.getAttribute(i) === o
      ))
        return !0;
      if (e.text) {
        const a = n.textContent?.trim() || "", i = e.text.normalized;
        if (a.includes(i) || i.includes(a))
          return !0;
      }
      return !1;
    }) || null : t.length > 0 ? t[0] : null;
  }
  /**
   * FIX 3: Gets nth selector - nth-child for tables, nth-of-type for others
   * This method is now ACTIVELY INTEGRATED in selector generation logic
   * to ensure table elements use position-specific nth-child selectors
   * @param element - Element to get selector for
   * @param tag - Tag name
   * @returns nth selector string (e.g., ":nth-child(2)" or ":nth-of-type(2)")
   */
  getNthSelector(t, e) {
    const s = t.parentElement;
    if (!s) return "";
    const n = Array.from(s.children), a = n.indexOf(t) + 1;
    return ["tr", "td", "th", "thead", "tbody", "tfoot"].includes(e) ? `:nth-child(${a})` : `:nth-of-type(${n.filter((c) => c.tagName.toLowerCase() === e).indexOf(t) + 1})`;
  }
  /**
   * Gets attribute priority for sorting
   * @param attrName - Attribute name
   * @returns Priority number (higher = more priority)
   */
  getAttributePriority(t) {
    return w[t] !== void 0 ? w[t] : t.startsWith("data-") ? w["data-*"] : t.startsWith("aria-") ? w["aria-*"] : 0;
  }
  /**
   * Checks if attribute should be ignored
   * @param attrName - Attribute name
   * @returns True if should be ignored
   */
  shouldIgnoreAttribute(t) {
    return !!(Y.has(t) || t.startsWith("on") || t.startsWith("ng-") || t.startsWith("_ng") || t.startsWith("data-reactid") || t.startsWith("data-react") || t.startsWith("data-v-"));
  }
  /**
   * Gets attributes sorted by priority
   * @param attributes - Attributes object
   * @returns Sorted array of attributes with priority
   */
  getSortedAttributes(t) {
    return Object.entries(t).filter(([e]) => !this.shouldIgnoreAttribute(e)).filter(
      ([e, s]) => !Z.has(e) || !K(s)
    ).map(([e, s]) => ({
      name: e,
      value: s,
      priority: this.getAttributePriority(e)
    })).filter((e) => e.priority > 0).sort((e, s) => s.priority - e.priority);
  }
  /**
   * Builds selector for a single node
   * Priority: ID → semantic attributes → role → classes
   */
  buildNodeSelector(t, e, s) {
    let n = t;
    if (e.id)
      return n += `#${this.escapeCSS(e.id)}`, n;
    if (e.attributes) {
      const a = this.getSortedAttributes(e.attributes);
      for (const { name: i, value: o } of a)
        i === "href" || i === "src" || o && (n += `[${i}="${this.escapeAttr(o)}"]`);
    }
    if (e.role && !e.attributes?.role && (n += `[role="${this.escapeAttr(e.role)}"]`), !s?.excludeClasses && e.classes && e.classes.length > 0) {
      const a = M(e.classes), i = s?.maxClasses !== void 0 ? a.slice(0, s.maxClasses) : a;
      n += i.map((o) => `.${this.escapeCSS(o)}`).join("");
    }
    return n;
  }
  /**
   * Escapes special characters for CSS selector
   */
  escapeCSS(t) {
    let e = t;
    return e.startsWith("-") && (e = "\\-" + e.slice(1)), e = e.replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, "\\$1"), e;
  }
  /**
   * Escapes quotes for attribute values
   */
  escapeAttr(t) {
    return t.replace(/"/g, '\\"').replace(/\\/g, "\\\\");
  }
  /**
   * Checks if element tag is an SVG child element
   * @param tag - Element tag name
   * @returns True if element is an SVG child
   */
  isSvgChildElement(t) {
    return At.includes(t);
  }
  /**
   * Builds CSS selector for elements inside <head>.
   * Uses child combinator (>) for strict structure: html > head > ... > target
   * @param eid - Element Identity with anchor=html and path[0]=head
   * @param options - Optional uniqueness control settings
   * @returns CSS selector string or BuildSelectorResult
   * @remarks
   * This method handles the special case where elements are inside <head>.
   * The selector always uses child combinators for strict parent-child relationships.
   * @example
   * For <html><head><meta name="description"></head></html>
   * Returns: "html > head > meta[name='description']"
   */
  buildHeadSelector(t, e) {
    const s = ["html"];
    for (const o of t.path) {
      let c = this.buildNodeSelector(o.tag, o.semantics);
      o.nthChild !== void 0 && (c += `:nth-child(${o.nthChild})`), s.push(c);
    }
    let n = this.buildNodeSelector(t.target.tag, t.target.semantics);
    t.target.nthChild !== void 0 && (n += `:nth-child(${t.target.nthChild})`), s.push(n);
    const a = s.join(" > ");
    if (!e?.ensureUnique)
      return a;
    const i = this.isUnique(a, e.root ?? document);
    return {
      selector: a,
      isUnique: i,
      usedNthOfType: a.includes(":nth-"),
      extraClassesAdded: 0
    };
  }
}
function at(r, t) {
  if (!r) return r;
  const e = oe(t);
  try {
    if (ae(r) || r.startsWith("//") || ie(r))
      return r;
    const s = new URL(r, e);
    if (!e)
      return r;
    const n = new URL(e);
    if (s.origin === n.origin) {
      let a = s.pathname;
      return s.search && (a += s.search), s.hash && (a += s.hash), a;
    }
    return r;
  } catch {
    return r;
  }
}
function ae(r) {
  return !r.startsWith("http://") && !r.startsWith("https://") && !r.startsWith("//");
}
function ie(r) {
  return ["javascript:", "mailto:", "tel:", "data:", "blob:", "file:"].some((e) => r.startsWith(e));
}
function oe(r) {
  if (r)
    return r;
  if (typeof window < "u" && window.location && window.location.href)
    return window.location.href;
}
function it(r) {
  if (!r || typeof r != "string")
    return "";
  if (r.startsWith("javascript:") || r.startsWith("mailto:") || r.startsWith("tel:") || r.startsWith("data:") || r.startsWith("blob:") || r.startsWith("/") || r.startsWith("./") || r.startsWith("../"))
    return r;
  try {
    const t = new URL(r);
    return t.pathname + t.search + t.hash;
  } catch {
    return r;
  }
}
class ce {
  /**
   * Filters elements that match the semantics
   * @param elements - Candidate elements
   * @param semantics - Target semantics to match
   * @param documentUrl - Optional document base URL for URL normalization (iframe context)
   * @param matchUrlsByPathOnly - Optional flag to match URLs by pathname only (ignoring origin)
   * @returns Filtered elements that match
   */
  match(t, e, s, n) {
    return t.filter(
      (a) => this.matchElement(a, e, s, n)
    );
  }
  /**
   * Checks if a single element matches the semantics
   * @param documentUrl - Optional document base URL for URL normalization (iframe context)
   * @param matchUrlsByPathOnly - Optional flag to match URLs by pathname only (ignoring origin)
   */
  matchElement(t, e, s, n) {
    return !(e.text && !this.matchText(t, e.text) || e.attributes && !this.matchAttributes(t, e.attributes, s, n) || e.svg && !this.matchSvgFingerprint(t, e.svg));
  }
  /**
   * Matches text content
   * Prioritizes direct text nodes, but falls back to full textContent if no direct text
   */
  matchText(t, e) {
    const a = Array.from(t.childNodes).filter(
      (o) => o.nodeType === Node.TEXT_NODE
    ).map((o) => o.textContent?.trim() ?? "").join(" ") || (t.textContent?.trim() ?? "");
    if (!a) return !1;
    const i = j(a);
    return e.matchMode === "partial" ? i.includes(e.normalized) : i === e.normalized;
  }
  /**
   * Lenient text matching - uses partial matching instead of exact
   * Used as fallback when exact matching fails
   */
  matchTextLenient(t, e) {
    const a = Array.from(t.childNodes).filter(
      (o) => o.nodeType === Node.TEXT_NODE
    ).map((o) => o.textContent?.trim() ?? "").join(" ") || (t.textContent?.trim() ?? "");
    if (!a) return !1;
    const i = j(a);
    return i.includes(e.normalized) || e.normalized.includes(i);
  }
  /**
   * Checks if a single element matches the semantics with lenient text matching
   * @param documentUrl - Optional document base URL for URL normalization (iframe context)
   * @param matchUrlsByPathOnly - Optional flag to match URLs by pathname only (ignoring origin)
   */
  matchElementLenient(t, e, s, n) {
    return !(e.text && !this.matchTextLenient(t, e.text) || e.attributes && !this.matchAttributes(t, e.attributes, s, n) || e.svg && !this.matchSvgFingerprint(t, e.svg));
  }
  /**
   * Filters elements with lenient matching (exported for use in resolver)
   * @param documentUrl - Optional document base URL for URL normalization (iframe context)
   * @param matchUrlsByPathOnly - Optional flag to match URLs by pathname only (ignoring origin)
   */
  matchLenient(t, e, s, n) {
    return t.filter(
      (a) => this.matchElementLenient(a, e, s, n)
    );
  }
  /**
   * Matches attributes with URL normalization for href/src
   * @param documentUrl - Optional document base URL for URL normalization (iframe context)
   * @param matchUrlsByPathOnly - Optional flag to match URLs by pathname only (ignoring origin, default: true)
   */
  matchAttributes(t, e, s, n = !0) {
    for (const [a, i] of Object.entries(e)) {
      const o = t.getAttribute(a);
      if (a === "href" || a === "src")
        if (n) {
          const c = D(a, i, {
            preserveQueryForAbsolute: !1
          }), l = D(a, o || "", {
            preserveQueryForAbsolute: !1
          }), f = it(c), h = it(l);
          if (f !== h)
            return !1;
        } else {
          const c = at(
            D(a, i, { preserveQueryForAbsolute: !1 }),
            s
          ), l = at(
            D(a, o || "", { preserveQueryForAbsolute: !1 }),
            s
          );
          if (c !== l)
            return !1;
        }
      else if (o !== i)
        return !1;
    }
    return !0;
  }
  /**
   * Matches SVG fingerprint
   */
  matchSvgFingerprint(t, e) {
    if (t.tagName.toLowerCase() !== e.shape)
      return !1;
    if (e.dHash && e.shape === "path") {
      const s = t.getAttribute("d");
      if (s && this.computePathHash(s) !== e.dHash)
        return !1;
    }
    return !(e.geomHash && ["circle", "rect", "ellipse", "line"].includes(e.shape) && this.computeGeomHash(t, e.shape) !== e.geomHash || e.titleText && t.querySelector("title")?.textContent?.trim() !== e.titleText);
  }
  /**
   * Computes simple path hash (matching SvgFingerprinter)
   */
  computePathHash(t) {
    const n = (t.match(/[MLHVCSQTAZ][^MLHVCSQTAZ]*/gi) ?? []).slice(0, 5).map((a) => a.trim().replace(/(-?\d+\.?\d*)/g, (i) => parseFloat(i).toFixed(1))).join(" ");
    return this.simpleHash(n);
  }
  /**
   * Computes geometry hash for non-path shapes (matching SvgFingerprinter)
   */
  computeGeomHash(t, e) {
    const s = [];
    switch (e) {
      case "circle":
        s.push(`r=${t.getAttribute("r") ?? "0"}`);
        break;
      case "rect": {
        const n = parseFloat(t.getAttribute("width") ?? "0"), a = parseFloat(t.getAttribute("height") ?? "0");
        n > 0 && a > 0 && s.push(`ratio=${(n / a).toFixed(2)}`);
        break;
      }
      case "ellipse": {
        const n = parseFloat(t.getAttribute("rx") ?? "0"), a = parseFloat(t.getAttribute("ry") ?? "0");
        n > 0 && a > 0 && s.push(`ratio=${(n / a).toFixed(2)}`);
        break;
      }
      case "line": {
        const n = parseFloat(t.getAttribute("x1") ?? "0"), a = parseFloat(t.getAttribute("y1") ?? "0"), i = parseFloat(t.getAttribute("x2") ?? "0"), o = parseFloat(t.getAttribute("y2") ?? "0"), c = Math.atan2(o - a, i - n);
        s.push(`angle=${c.toFixed(2)}`);
        break;
      }
    }
    return this.simpleHash(s.join(";"));
  }
  /**
   * Simple hash function (matching SvgFingerprinter)
   */
  simpleHash(t) {
    let e = 0;
    for (let s = 0; s < t.length; s++) {
      const n = t.charCodeAt(s);
      e = (e << 5) - e + n, e = e & e;
    }
    return Math.abs(e).toString(16).padStart(8, "0");
  }
}
class le {
  /**
   * Applies a single constraint to candidates
   * @param candidates - Current candidate elements
   * @param constraint - Constraint to apply
   * @returns Filtered candidates
   */
  applyConstraint(t, e) {
    switch (e.type) {
      case "text-proximity":
        return this.applyTextProximity(
          t,
          e.params
        );
      case "position":
        return this.applyPosition(t, e.params);
      default:
        return t;
    }
  }
  /**
   * Applies text proximity constraint using Levenshtein distance
   */
  applyTextProximity(t, e) {
    return t.filter((s) => {
      const n = s.textContent?.trim() ?? "";
      return this.levenshteinDistance(n, e.reference) <= e.maxDistance;
    });
  }
  /**
   * Applies position constraint
   */
  applyPosition(t, e) {
    if (t.length <= 1) return t;
    switch (e.strategy) {
      case "first-in-dom":
        return [t[0]];
      case "top-most":
        return [this.getTopMost(t)];
      case "left-most":
        return [this.getLeftMost(t)];
      default:
        return [t[0]];
    }
  }
  /**
   * Gets the top-most element by bounding rect
   */
  getTopMost(t) {
    return t.reduce((e, s) => {
      try {
        const n = e.getBoundingClientRect();
        return s.getBoundingClientRect().top < n.top ? s : e;
      } catch {
        return e;
      }
    });
  }
  /**
   * Gets the left-most element by bounding rect
   */
  getLeftMost(t) {
    return t.reduce((e, s) => {
      try {
        const n = e.getBoundingClientRect();
        return s.getBoundingClientRect().left < n.left ? s : e;
      } catch {
        return e;
      }
    });
  }
  /**
   * Calculates Levenshtein distance between two strings
   */
  levenshteinDistance(t, e) {
    if (t === e) return 0;
    if (t.length === 0) return e.length;
    if (e.length === 0) return t.length;
    const s = Array.from({ length: e.length + 1 }, (n, a) => a);
    for (let n = 1; n <= t.length; n++) {
      let a = n;
      for (let i = 1; i <= e.length; i++) {
        const o = t[n - 1] === e[i - 1] ? s[i - 1] : Math.min(s[i - 1], a, s[i]) + 1;
        s[i - 1] = a, a = o;
      }
      s[e.length] = a;
    }
    return s[e.length];
  }
}
class he {
  constructor() {
    this.cssGenerator = new ht();
  }
  /**
   * Handles fallback when resolution fails
   * @param eid - Element Identity being resolved
   * @param dom - Document or element to search in
   * @returns Fallback resolution result
   */
  handleFallback(t, e) {
    const { onMissing: s } = t.fallback;
    switch (s) {
      case "anchor-only":
        return this.fallbackToAnchor(t, e);
      case "strict":
        return {
          status: "error",
          elements: [],
          warnings: ["Element not found (strict mode)"],
          confidence: 0,
          meta: { degraded: !0, degradationReason: "strict-not-found" }
        };
      default:
        return {
          status: "error",
          elements: [],
          warnings: ["Element not found"],
          confidence: 0,
          meta: { degraded: !0, degradationReason: "not-found" }
        };
    }
  }
  /**
   * Attempts to find and return the anchor element as fallback
   */
  fallbackToAnchor(t, e) {
    const s = this.cssGenerator.buildAnchorSelector(t), n = e instanceof Document ? e : e.ownerDocument ?? e;
    try {
      const a = n.querySelector(s);
      if (a)
        return {
          status: "degraded-fallback",
          elements: [a],
          warnings: ["Target not found, returning anchor"],
          confidence: t.meta.confidence * 0.3,
          meta: { degraded: !0, degradationReason: "anchor-fallback" }
        };
    } catch (a) {
      const i = a instanceof Error ? a.message : "Unknown selector error";
      return {
        status: "error",
        elements: [],
        warnings: [`Invalid anchor selector: ${i}`],
        confidence: 0,
        meta: { degraded: !0, degradationReason: "invalid-anchor-selector" }
      };
    }
    return {
      status: "error",
      elements: [],
      warnings: ["Anchor also not found"],
      confidence: 0,
      meta: { degraded: !0, degradationReason: "anchor-not-found" }
    };
  }
  /**
   * Handles ambiguous results (multiple matches)
   * @param elements - All matching elements
   * @param eid - Original Element Identity
   * @returns Resolution result based on fallback rules
   */
  handleAmbiguous(t, e) {
    const { onMultiple: s } = e.fallback;
    switch (s) {
      case "first":
        return {
          status: "success",
          elements: [t[0]],
          warnings: ["Multiple matches, returning first"],
          confidence: e.meta.confidence * 0.7,
          meta: { degraded: !0, degradationReason: "first-of-multiple" }
        };
      case "best-score":
        return this.selectBestScoring(t, e);
      default:
        return {
          status: "ambiguous",
          elements: t,
          warnings: [`Multiple matches: ${t.length}`],
          confidence: e.meta.confidence * 0.5,
          meta: { degraded: !0, degradationReason: "multiple-matches" }
        };
    }
  }
  /**
   * Selects the best-scoring element from candidates
   * Re-scores each element based on semantic match quality
   */
  selectBestScoring(t, e) {
    const s = e.target.semantics;
    let n = t[0], a = -1;
    for (const i of t) {
      const o = this.scoreElementMatch(i, s);
      o > a && (a = o, n = i);
    }
    return {
      status: "success",
      elements: [n],
      warnings: [`Multiple matches (${t.length}), selected best-scoring element`],
      confidence: e.meta.confidence * (0.7 + a * 0.2),
      meta: { degraded: !0, degradationReason: "best-of-multiple" }
    };
  }
  /**
   * Scores how well an element matches the target semantics
   * @returns Score from 0 to 1
   */
  scoreElementMatch(t, e) {
    let s = 0, n = 0;
    if (e.id && (n += 0.3, t.id === e.id && (s += 0.3)), e.classes && e.classes.length > 0) {
      n += 0.25;
      const a = Array.from(t.classList), i = e.classes.filter(
        (o) => a.includes(o)
      ).length;
      s += i / e.classes.length * 0.25;
    }
    if (e.attributes) {
      const a = Object.entries(e.attributes);
      if (a.length > 0) {
        n += 0.2;
        let i = 0;
        for (const [o, c] of a)
          t.getAttribute(o) === c && i++;
        s += i / a.length * 0.2;
      }
    }
    if (e.role && (n += 0.15, t.getAttribute("role") === e.role && (s += 0.15)), e.text) {
      n += 0.1;
      const a = j(t.textContent);
      a === e.text.normalized ? s += 0.1 : a.includes(e.text.normalized) && (s += 0.05);
    }
    return n > 0 ? s / n : 0;
  }
}
function ue(r, t, e = {}) {
  const s = { ...Ct, ...e };
  let n;
  try {
    t instanceof Document ? n = t : n = k(t);
  } catch (p) {
    const b = p instanceof Error ? p.message : "Unknown error";
    return {
      status: "error",
      elements: [],
      warnings: ["Failed to resolve document context", b],
      confidence: 0,
      meta: { degraded: !0, degradationReason: "invalid-context" }
    };
  }
  if (s.root) {
    const p = s.root instanceof Document ? s.root : s.root.ownerDocument;
    p && p !== n && console.warn(
      "options.root does not match dom parameter document. Using document from dom parameter. This may indicate a cross-document operation issue."
    );
  }
  const a = s.documentUrl ?? n.defaultView?.location?.href, i = s.matchUrlsByPathOnly ?? !0, o = new ht(), c = new ce(), l = new le(), f = new he(), h = o.buildSelector(r, {
    ensureUnique: !1,
    root: n
  });
  let d;
  try {
    d = Array.from(n.querySelectorAll(h));
  } catch (p) {
    const b = p instanceof Error ? p.message : "Unknown selector error";
    return {
      status: "error",
      elements: [],
      warnings: [`Invalid CSS selector: ${h}`, `Error: ${b}`],
      confidence: 0,
      meta: { degraded: !0, degradationReason: "invalid-selector" }
    };
  }
  const u = d.length;
  d.length > s.maxCandidates && (d = d.slice(0, s.maxCandidates));
  const g = c.match(
    d,
    r.target.semantics,
    a,
    i
  );
  if (g.length === 0 && u > 0 && r.target.semantics.text !== void 0) {
    const p = c.matchLenient(
      d,
      r.target.semantics,
      a,
      i
    );
    if (p.length > 0) {
      if (p.length === 1)
        return {
          status: "success",
          elements: p,
          warnings: ["Used relaxed text matching due to exact match failure"],
          confidence: r.meta.confidence * 0.8,
          // Slight confidence penalty
          meta: { degraded: !0, degradationReason: "relaxed-text-matching" }
        };
      const b = ot(
        p,
        r,
        l,
        f,
        n,
        s,
        1
        // No penalty here - lenient penalty applied to final result
      );
      if (b.elements.length > 0)
        return {
          ...b,
          warnings: [...b.warnings, "Used relaxed text matching"],
          confidence: b.confidence * 0.8
          // Apply lenient matching penalty (20% degradation)
        };
    }
  }
  if (g.length === 1)
    return {
      status: "success",
      elements: g,
      warnings: [],
      confidence: r.meta.confidence,
      meta: { degraded: !1 }
    };
  if (g.length === 0) {
    const p = u > 0 ? `CSS selector found ${u} candidates but semantic filtering rejected all. This may indicate text content mismatch.` : "CSS selector found no candidates";
    if (s.enableFallback) {
      const b = f.handleFallback(r, n);
      return {
        ...b,
        warnings: [...b.warnings, p]
      };
    }
    return {
      status: "error",
      elements: [],
      warnings: ["No matching elements found", p],
      confidence: 0,
      meta: { degraded: !0, degradationReason: "not-found" }
    };
  }
  return ot(
    g,
    r,
    l,
    f,
    n,
    s,
    1
    // no confidence penalty for exact match path
  );
}
function de(r) {
  return [...r].sort((t, e) => e.priority - t.priority);
}
function ot(r, t, e, s, n, a, i) {
  let o = r;
  const c = de(t.constraints);
  for (const f of c) {
    if (o = e.applyConstraint(o, f), o.length === 1)
      return {
        status: "success",
        elements: o,
        warnings: [],
        confidence: t.meta.confidence * 0.9 * i,
        meta: { degraded: !1 }
      };
    if (o.length === 0)
      return a.enableFallback ? s.handleFallback(t, n) : {
        status: "error",
        elements: [],
        warnings: ["Constraints eliminated all candidates"],
        confidence: 0,
        meta: { degraded: !0, degradationReason: "over-constrained" }
      };
  }
  if (a.strictMode)
    return {
      status: "ambiguous",
      elements: o,
      warnings: [`Non-unique resolution: ${o.length} matches`],
      confidence: t.meta.confidence * 0.7 * i,
      meta: { degraded: !0, degradationReason: "ambiguous" }
    };
  const l = s.handleAmbiguous(o, t);
  return {
    ...l,
    confidence: l.confidence * i
  };
}
function $e(r) {
  const t = [], e = [];
  if (r.version ? r.version !== "1.0" && e.push(`Unknown version: ${r.version}`) : t.push("Missing version field"), r.anchor ? (r.anchor.tag || t.push("Anchor missing tag"), typeof r.anchor.score != "number" && t.push("Anchor missing score"), r.anchor.semantics || t.push("Anchor missing semantics")) : t.push("Missing anchor field"), r.target ? (r.target.tag || t.push("Target missing tag"), typeof r.target.score != "number" && t.push("Target missing score"), r.target.semantics || t.push("Target missing semantics")) : t.push("Missing target field"), !Array.isArray(r.path))
    t.push("Path must be an array");
  else
    for (let s = 0; s < r.path.length; s++) {
      const n = r.path[s];
      n.tag || t.push(`Path node ${s} missing tag`), n.semantics || t.push(`Path node ${s} missing semantics`);
    }
  return r.meta ? (typeof r.meta.confidence != "number" && e.push("Missing confidence score"), r.meta.generatedAt || e.push("Missing generatedAt timestamp")) : t.push("Missing meta field"), Array.isArray(r.constraints) || e.push("Constraints should be an array"), r.fallback || e.push("Missing fallback rules"), {
    valid: t.length === 0,
    errors: t,
    warnings: e
  };
}
function Ne(r) {
  if (!r || typeof r != "object") return !1;
  const t = r;
  return typeof t.version == "string" && typeof t.anchor == "object" && Array.isArray(t.path) && typeof t.target == "object";
}
const ut = {
  id: "i",
  "data-testid": "tid",
  "data-qa": "qa",
  "data-cy": "cy",
  "data-test": "dt",
  "aria-label": "al",
  "aria-labelledby": "alb",
  "aria-describedby": "adb",
  name: "n",
  href: "h",
  src: "s",
  type: "t",
  role: "r",
  alt: "at",
  title: "tt",
  for: "f",
  placeholder: "ph",
  text: "x"
}, G = Object.fromEntries(
  Object.entries(ut).map(([r, t]) => [t, r])
), dt = {
  maxClasses: 2,
  maxAttributes: 5,
  includeText: !0,
  maxTextLength: 50,
  simplifyTarget: !0,
  includeConstraints: !0,
  format: "compact"
};
function ct(r) {
  return r === "id" ? 101 : w[r] !== void 0 ? w[r] : r.startsWith("data-") ? w["data-*"] : r.startsWith("aria-") ? w["aria-*"] : 0;
}
function fe(r) {
  return ["id", "data-testid", "data-qa", "data-cy", "href", "text", "role"].includes(r);
}
function ge(r) {
  return !!(/@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(r) || /(\+?\d{1,3}[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/.test(r) || /\d{4}[-\s]?\d{4}[-\s]?\d{4}[-\s]?\d{4}/.test(r));
}
function me(r, t) {
  const e = { ...dt, ...t }, s = e.format === "compact", n = s ? "v1" : `v${r.version}`, a = s ? ":" : ": ", i = s ? "::" : " :: ", o = s ? ">" : " > ", c = e.includeText && r.target.semantics.text ? r.target.semantics.text.normalized : void 0, l = W(r.anchor, !1, e), f = r.path.length > 0 ? r.path.map((u) => W(u, !1, e, c)).join(o) + o : "", h = W(r.target, !0, e), d = e.includeConstraints ? be(r, e) : "";
  return `${n}${a}${l}${i}${f}${h}${d}`;
}
function pe(r) {
  r = r.trim();
  const t = r.match(/^v(\d+(?:\.\d+)?)\s*:\s*/);
  if (!t)
    throw new Error('Invalid SEQL Selector: missing version prefix (expected "v1:")');
  const e = t[1];
  if (e !== "1.0" && e !== "1")
    throw new Error(`Unsupported SEQL Selector version: v${e} (only v1.0 is supported)`);
  let s = r.slice(t[0].length);
  const n = s.match(/^(.+?)\s*::\s*/);
  if (!n)
    throw new Error('Invalid SEQL Selector: missing anchor separator "::"');
  const a = n[1].trim();
  s = s.slice(n[0].length);
  const i = s.match(/\s*\{([^}]+)\}\s*$/);
  let o = "";
  i && (o = i[1], s = s.slice(0, i.index));
  const c = s.split(/\s*>\s*/).map((p) => p.trim()).filter((p) => p);
  if (c.length === 0)
    throw new Error("Invalid SEQL Selector: missing target node");
  const l = c[c.length - 1], f = c.slice(0, -1), h = B(a, !0), d = f.map((p) => B(p, !1)), u = B(l, !1), g = ye(o);
  return {
    version: "1.0",
    anchor: h,
    path: d,
    target: u,
    constraints: g,
    fallback: {
      onMultiple: "best-score",
      onMissing: "anchor-only",
      maxDepth: 10
    },
    meta: {
      confidence: 0.7,
      generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
      generator: "seql-parser@1.0",
      source: "seql-string",
      degraded: !1
    }
  };
}
function W(r, t = !1, e = dt, s) {
  const { tag: n, semantics: a } = r, i = e.format === "compact";
  let o = n;
  const c = [], l = { ...a.attributes };
  a.id && (l.id = a.id), a.role && !l.role && (l.role = a.role);
  const f = Object.entries(l).map(([u, g]) => {
    const m = ct(u), p = u === "href" || u === "src" ? D(u, g) : g;
    return { name: u, value: p, priority: m };
  }).filter((u) => u.name !== "id" && u.name !== "class" && Y.has(u.name) || Z.has(u.name) && K(u.value) ? !1 : u.priority > 0 || u.name === "role" || u.name === "id");
  f.sort((u, g) => g.priority - u.priority);
  const h = f.slice(0, e.maxAttributes);
  h.sort((u, g) => u.name.localeCompare(g.name));
  for (const { name: u, value: g } of h) {
    const m = i ? ut[u] ?? u : u;
    c.push(`${m}="${V(g)}"`);
  }
  if (e.includeText && a.text && !ge(a.text.normalized)) {
    const u = a.text.normalized;
    if (u.length > 0 && u.length <= e.maxTextLength && !(!t && s !== void 0 && u === s)) {
      const m = i ? "x" : "text";
      c.push(`${m}="${V(u)}"`);
    }
  }
  let d = c;
  if (c.length > 0 && t && e.simplifyTarget && a.id && (d = c.filter((u) => {
    const g = u.split("=")[0], m = G[g] ?? g;
    return ct(m) >= 60 || m === "text" || m === "id" || m === "role";
  })), a.classes && a.classes.length > 0) {
    const u = M(a.classes), g = !!a.id || c.some((p) => {
      const b = p.split("=")[0], y = G[b] ?? b;
      return y === "href" || y === "data-testid" || y === "text" || y === "role";
    });
    if (!(t && e.simplifyTarget && g) && u.length > 0) {
      const p = u.sort().slice(0, e.maxClasses);
      o += p.map((b) => `.${b}`).join("");
    }
  }
  if (d.length > 0 && (o += `[${d.join(",")}]`), "nthChild" in r && r.nthChild) {
    const u = !!a.id || a.attributes && Object.keys(a.attributes).some(fe);
    t && e.simplifyTarget && u || (o += `#${r.nthChild}`);
  }
  return o;
}
function be(r, t) {
  if (!r.constraints || r.constraints.length === 0)
    return "";
  const e = [];
  for (const n of r.constraints)
    switch (n.type) {
      case "uniqueness":
        e.push("unique=true");
        break;
      case "position":
        n.params && n.params.strategy && e.push(`pos=${n.params.strategy}`);
        break;
      case "text-proximity":
        if (n.params && n.params.reference) {
          const a = V(String(n.params.reference));
          e.push(`text="${a}"`);
        }
        break;
    }
  return e.length === 0 ? "" : `${t.format === "verbose" ? " " : ""}{${e.join(",")}}`;
}
function B(r, t) {
  let e = r;
  const s = {}, n = e.match(/^([a-z][a-z0-9-]*)/);
  if (!n)
    throw new Error(`Invalid node: missing tag name in "${r}"`);
  const a = n[1];
  e = e.slice(a.length);
  const i = [];
  let o;
  for (; o = e.match(/^\.([a-zA-Z][a-zA-Z0-9-_]*)/); )
    i.push(o[1]), e = e.slice(o[0].length);
  i.length > 0 && (s.classes = i);
  const c = e.match(/^\[([^\]]+)\]/);
  if (c) {
    const h = c[1], d = {}, u = Se(h);
    for (const g of u) {
      const m = g.match(/^([a-z][a-z0-9-]*)(?:=|~=)"((?:[^"\\]|\\.)*)"/);
      if (m) {
        const [, p, b] = m, y = G[p] ?? p;
        d[y] = ft(b);
      }
    }
    Object.keys(d).length > 0 && (d.text && (s.text = {
      raw: d.text,
      normalized: d.text
    }, delete d.text), d.id && (s.id = d.id, delete d.id), d.role && (s.role = d.role, delete d.role), Object.keys(d).length > 0 && (s.attributes = d)), e = e.slice(c[0].length);
  }
  let l;
  const f = e.match(/^#(\d+)/);
  if (f && (l = parseInt(f[1], 10), e = e.slice(f[0].length)), e.trim())
    throw new Error(`Invalid node: unexpected content "${e}" in "${r}"`);
  return t ? {
    tag: a,
    semantics: s,
    score: 0.7,
    degraded: !1
  } : {
    tag: a,
    semantics: s,
    score: 0.7,
    nthChild: l
  };
}
function ye(r) {
  if (!r.trim())
    return [];
  const t = [], e = r.split(",").map((s) => s.trim());
  for (const s of e) {
    const [n, a] = s.split("=").map((i) => i.trim());
    switch (n) {
      case "unique":
        a === "true" && t.push({
          type: "uniqueness",
          params: {
            mode: "strict"
          },
          priority: 90
        });
        break;
      case "pos":
        t.push({
          type: "position",
          params: {
            strategy: a
          },
          priority: 70
        });
        break;
      case "text": {
        const i = a.replace(/^"(.*)"$/, "$1");
        t.push({
          type: "text-proximity",
          params: {
            reference: ft(i),
            maxDistance: 5
          },
          priority: 60
        });
        break;
      }
    }
  }
  return t;
}
function Se(r) {
  const t = [];
  let e = "", s = !1;
  for (let n = 0; n < r.length; n++) {
    const a = r[n];
    a === '"' && (n === 0 || r[n - 1] !== "\\") ? (s = !s, e += a) : a === "," && !s ? (e.trim() && t.push(e.trim()), e = "") : e += a;
  }
  return e.trim() && t.push(e.trim()), t;
}
function V(r) {
  return r.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/>/g, "\\>").replace(/:/g, "\\:");
}
function ft(r) {
  return r.replace(/\\\\/g, "\0").replace(/\\"/g, '"').replace(/\\>/g, ">").replace(/\\:/g, ":").replace(/\x00/g, "\\");
}
function Ie(r, t, e) {
  const s = J(r, t);
  return s ? me(s, e) : null;
}
function Re(r, t, e) {
  try {
    const s = pe(r), n = {
      ...e,
      root: e?.root || t
    };
    return ue(s, t, n).elements || [];
  } catch (s) {
    return console.error("Failed to resolve SEQL Selector:", s), [];
  }
}
const Ae = /* @__PURE__ */ new Set(["script", "style", "noscript", "meta", "link", "head", "title"]);
function Q(r) {
  return r.id && !L(r.id) ? 3 : r.hasAttribute("role") || r.hasAttribute("aria-label") || r.hasAttribute("aria-labelledby") || r.hasAttribute("data-testid") || r.hasAttribute("data-qa") || r.hasAttribute("data-test") ? 2 : 1;
}
function gt(r, t) {
  const e = r.tagName.toLowerCase();
  return !!(Ae.has(e) || t && Q(r) === 1 && ![
    "form",
    "main",
    "nav",
    "section",
    "article",
    "footer",
    "header",
    "button",
    "a",
    "input",
    "label",
    "select",
    "textarea"
  ].includes(e));
}
function mt(r) {
  return [...r].sort((t, e) => {
    const s = Q(t);
    return Q(e) - s;
  });
}
function De(r = {}) {
  const t = performance.now();
  let {
    root: e,
    filter: s = "*",
    limit: n = 1 / 0,
    onProgress: a,
    progressInterval: i = 100,
    skipNonSemantic: o = !0,
    generatorOptions: c = {},
    cache: l,
    signal: f
  } = r;
  const h = l ?? X(), d = { ...c, cache: h };
  let u;
  try {
    if (e)
      e instanceof Document, u = Array.from(e.querySelectorAll(s));
    else if (typeof document < "u")
      u = Array.from(document.querySelectorAll(s));
    else
      throw new Error("Root element or document is required when document is not available");
  } catch {
    return {
      results: [],
      failed: [],
      stats: {
        totalElements: 0,
        successful: 0,
        failed: 0,
        skipped: 0,
        totalTimeMs: 0,
        avgTimePerElementMs: 0,
        cacheHitRate: 0
      }
    };
  }
  if (!e) {
    if (u.length === 0)
      throw new Error("Root element or document is required when no elements are found");
    const x = k(u[0]);
    e = x.body || x.documentElement;
  }
  const g = e instanceof Document ? e : k(e);
  u.forEach((x, S) => {
    if (k(x) !== g)
      throw new Error(
        `Batch generation requires all elements from the same document. Element at index ${S} is from a different document. If working with iframes, ensure all elements are from the same iframe's contentDocument.`
      );
  });
  const m = u.filter((x) => !gt(x, o)), b = mt(m).slice(0, n), y = [], T = [];
  let C = 0;
  const A = b.length;
  let v = 0;
  for (let x = 0; x < b.length && !f?.aborted; x++) {
    const S = b[x], O = h.getEID(S);
    if (O)
      y.push({
        element: S,
        eid: O,
        generationTimeMs: 0
        // Cached, no generation time
      });
    else {
      const pt = performance.now();
      try {
        const H = J(S, d), bt = performance.now() - pt;
        H ? y.push({
          element: S,
          eid: H,
          generationTimeMs: bt
        }) : C++;
      } catch (H) {
        T.push({
          element: S,
          error: H instanceof Error ? H.message : String(H)
        });
      }
    }
    a && x - v >= i && (a(x + 1, A), v = x);
  }
  a && a(A, A);
  const P = performance.now() - t, $ = h.getStats(), E = $.eidHits + $.eidMisses + $.selectorHits + $.selectorMisses, R = $.eidHits + $.selectorHits, N = E > 0 ? R / E : 0;
  return {
    results: y,
    failed: T,
    stats: {
      totalElements: A,
      successful: y.length,
      failed: T.length,
      skipped: C,
      totalTimeMs: P,
      avgTimePerElementMs: y.length > 0 ? P / y.length : 0,
      cacheHitRate: N
    }
  };
}
function Me(r, t = {}) {
  const e = performance.now(), {
    limit: s = 1 / 0,
    onProgress: n,
    progressInterval: a = 100,
    skipNonSemantic: i = !0,
    generatorOptions: o = {},
    cache: c,
    signal: l
  } = t, f = c ?? X(), h = { ...o, cache: f }, d = r.filter((E) => !gt(E, i)), g = mt(d).slice(0, s), m = [], p = [];
  let b = 0;
  const y = g.length;
  let T = 0;
  for (let E = 0; E < g.length && !l?.aborted; E++) {
    const R = g[E], N = f.getEID(R);
    if (N)
      m.push({
        element: R,
        eid: N,
        generationTimeMs: 0
      });
    else {
      const x = performance.now();
      try {
        const S = J(R, h), O = performance.now() - x;
        S ? m.push({
          element: R,
          eid: S,
          generationTimeMs: O
        }) : b++;
      } catch (S) {
        p.push({
          element: R,
          error: S instanceof Error ? S.message : String(S)
        });
      }
    }
    n && E - T >= a && (n(E + 1, y), T = E);
  }
  n && n(y, y);
  const C = performance.now() - e, A = f.getStats(), v = A.eidHits + A.eidMisses + A.selectorHits + A.selectorMisses, P = A.eidHits + A.selectorHits, $ = v > 0 ? P / v : 0;
  return {
    results: m,
    failed: p,
    stats: {
      totalElements: y,
      successful: m.length,
      failed: p.length,
      skipped: b,
      totalTimeMs: C,
      avgTimePerElementMs: m.length > 0 ? C / m.length : 0,
      cacheHitRate: $
    }
  };
}
export {
  Tt as AnchorFinder,
  le as ConstraintsEvaluator,
  ht as CssGenerator,
  xt as DEFAULT_GENERATOR_OPTIONS,
  Ct as DEFAULT_RESOLVER_OPTIONS,
  Jt as EIDCache,
  xe as EID_VERSION,
  he as FallbackHandler,
  Ce as MAX_PATH_DEPTH,
  Ht as PathBuilder,
  et as ROLE_ANCHOR_VALUES,
  tt as SEMANTIC_ANCHOR_TAGS,
  Te as SEMANTIC_ATTRIBUTES,
  St as SEMANTIC_TAGS,
  nt as SemanticExtractor,
  ce as SemanticsMatcher,
  Zt as SvgFingerprinter,
  Kt as calculateConfidence,
  we as calculateElementScore,
  te as createEIDCache,
  Rt as filterClasses,
  J as generateEID,
  De as generateEIDBatch,
  Me as generateEIDForElements,
  Ie as generateSEQL,
  Ee as getClassScore,
  X as getGlobalCache,
  Ne as isEID,
  st as isUtilityClass,
  j as normalizeText,
  pe as parseSEQL,
  ve as resetGlobalCache,
  ue as resolve,
  Re as resolveSEQL,
  me as stringifySEQL,
  $e as validateEID
};
//# sourceMappingURL=seql-js.js.map
